// @ts-nocheck

"use strict";

angular.module('yaltyApp', ['ngCookies', 'timer', 'ngSanitize', 'ui.router', 'ngMaterial', 'ngMessages', 'ngFileUpload', 'minicolors', 'chart.js', 'dndLists'])
    .config(function ($stateProvider, $locationProvider, $urlRouterProvider, $mdDateLocaleProvider, minicolorsProvider) {
        $locationProvider.html5Mode(true);
        //$locationProvider.hashPrefix('');
        angular.extend(minicolorsProvider.defaults, {
            control: 'hue',
            position: 'top right',
            letterCase: 'uppercase',
        });
        $mdDateLocaleProvider.firstDayOfWeek = 1;
        $mdDateLocaleProvider.months = ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'];
        moment.locale('hu');
        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return (m.isValid() ? m.format('YYYY. MMMM DD.') : null);
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, ['YYYY. MMMM D.', 'YYYY. M. D.'], true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
        $mdDateLocaleProvider.isDateComplete = function () {
            return true
        }
        $stateProvider
            .state('partner', {
                url: "/partner",
                templateUrl: '../views/headerPartner_EN.html?v=202402291115',
                hideMenus: true,
                redirectTo: "partner.login"
            })
            .state('partner.login', {
                url: "/login",
                templateUrl: '../views/login_EN.html?v=202402081402',
                onEnter: function ($window, $timeout) {
                    // Title beállítása 
                    $window.document.title = "Partner login";
                    // Meta description beállítása
                    $timeout(function () {
                        var metaDescription = document.querySelector('meta[name="description"]');
                        if (!metaDescription) {
                            metaDescription = document.createElement('meta');
                            metaDescription.name = "description";
                            document.getElementsByTagName('head')[0].appendChild(metaDescription);
                        }
                        metaDescription.content = "Log in here if you already have a Yalty partner account.";
                    }, 0);
                },
                hideMenus: true
            })
            .state('partner.contact', {
                url: "/contact",
                templateUrl: '../views/signup_EN.html?v=202505151415',
                onEnter: function ($window, $timeout) {
                    // Title beállítása 
                    $window.document.title = "Partner contact page";
                    // Meta description beállítása
                    $timeout(function () {
                        var metaDescription = document.querySelector('meta[name="description"]');
                        if (!metaDescription) {
                            metaDescription = document.createElement('meta');
                            metaDescription.name = "description";
                            document.getElementsByTagName('head')[0].appendChild(metaDescription);
                        }
                        metaDescription.content = "Contact us about loyalty cards and getting started.";
                    }, 0);
                },
                hideMenus: true
            })
            .state('partner.resetPartnerUserPassword', {
                url: "/resetPartnerUserPassword",
                onEnter: function ($window) { $window.document.title = "Forgotten password"; },
                templateUrl: '../views/forgottenPass_EN.html?v=202405311022',
            })
            .state('index', {
                url: "/index",
                templateUrl: '../views/headerYalty_EN.html?v=202501271141',
                controller: 'AppCtrl',
                onEnter: function ($window, $timeout) {
                    // Title beállítása 
                    $window.document.title = "Yalty app - All your loyalty cards in one place";
                    // Meta description beállítása
                    $timeout(function () {
                        var metaDescription = document.querySelector('meta[name="description"]');
                        if (!metaDescription) {
                            metaDescription = document.createElement('meta');
                            metaDescription.name = "description";
                            document.getElementsByTagName('head')[0].appendChild(metaDescription);
                        }
                        metaDescription.content = "All your loyalty cards in one place. Always with you, digitally on your mobile.";
                    }, 0);
                },
                redirectTo: 'index.home'
            })
            .state('index.home', {
                url: "/",
                views: {
                    "main": {
                        templateUrl: '../views/main_EN.html?v=202408210936',
                    },
                    "yaltyApp": {
                        templateUrl: '../views/yaltyApp_EN.html?v=202408261223',
                    },
                    "footer": {
                        templateUrl: '../views/footer_EN.html?v=202402291115',
                    }
                }, params: {
                    obj: null
                }
            })
            .state('partner_HU', {
                url: "/partnerHU",
                templateUrl: '../views/headerPartner_HU.html?v=202402290803',
                params: {
                    'errorText': null,
                },
                redirectTo: "partner_HU.login"
            })
            /*.state('partner_HU.login?redirectToPayment&emailAddress', {
                url: '/loginHU',
                onEnter: function ($window) { $window.document.title = "yalty | Digital Customer Engagement"; },
                templateUrl: '../views/login_HU.html?v=202007230919',
                params: {
                    redirectToPayment: {dynamic: true},
                    emailAddress: {dynamic: true},
                    'errorText': null
                },
            })*/
            .state('partner_HU.partnerHome', {
                url: "/partnerHomeHU",
                onEnter: function ($window, $timeout) {
                    // Title beállítása 
                    $window.document.title = "Yalty Partner - A kis- és középvállalkozások hűségprogramja";
                    // Meta description beállítása
                    $timeout(function () {
                        var metaDescription = document.querySelector('meta[name="description"]');
                        if (!metaDescription) {
                            metaDescription = document.createElement('meta');
                            metaDescription.name = "description";
                            document.getElementsByTagName('head')[0].appendChild(metaDescription);
                        }
                        metaDescription.content = "Digitális, pecsételős hűségprogram akár néhány órán belül.";
                    }, 0);
                },
                templateUrl: '../views/partnerHome_HU.html?v=202410181518'
            })
            .state('partner_HU.login', {
                url: "/loginHU",
                onEnter: function ($window, $timeout) {
                    // Title beállítása 
                    $window.document.title = "Partneri bejelentkezés";
                    // Meta description beállítása
                    $timeout(function () {
                        var metaDescription = document.querySelector('meta[name="description"]');
                        if (!metaDescription) {
                            metaDescription = document.createElement('meta');
                            metaDescription.name = "description";
                            document.getElementsByTagName('head')[0].appendChild(metaDescription);
                        }
                        metaDescription.content = "Jelentkezzen be itt, ha már van Yalty partneri fiókja.";
                    }, 0);
                },
                templateUrl: '../views/login_HU.html?v=202402081402',
                params: {
                    'errorText': null,
                },
            })
            .state('cashRegisterLogin', {
                url: "/login-minimal-display",
                onEnter: function ($window) { $window.document.title = "yalty | Digital Customer Engagement"; },
                templateUrl: '../views/login_HU.html?v=202402081402',
                params: {
                    'errorText': null,
                },
            })
            .state('partner_HU.contact', {
                url: "/contactHU",
                onEnter: function ($window, $timeout) {
                    // Title beállítása 
                    $window.document.title = "Partner kapcsolati lap";
                    // Meta description beállítása
                    $timeout(function () {
                        var metaDescription = document.querySelector('meta[name="description"]');
                        if (!metaDescription) {
                            metaDescription = document.createElement('meta');
                            metaDescription.name = "description";
                            document.getElementsByTagName('head')[0].appendChild(metaDescription);
                        }
                        metaDescription.content = "Vegye fel velünk a kapcsolatot a hűségkártyákkal és az indulással kapcsolatban.";
                    }, 0);
                },
                templateUrl: '../views/signup_HU.html?v=202402291102',
                hideMenus: true
            })
            .state('partner_HU.resetPartnerUserPassword', {
                url: "/resetPartnerUserPasswordHU",
                onEnter: function ($window) { $window.document.title = "Elfelejtett jelszó"; },
                templateUrl: '../views/forgottenPass_HU.html?v=202405311022',
            })
            .state('index_HU', {
                url: "/indexHU",
                templateUrl: '../views/headerYalty_HU.html?v=202501271123',
                controller: 'AppCtrl',
                redirectTo: "index_HU.home"
            })
            .state('index_HU.home', {
                url: "/home",
                templateUrl: '../views/publicContent.html?v=202408261223',
                onEnter: function ($window, $timeout) {
                    // Title beállítása 
                    $window.document.title = "Yalty app - Minden hűségkártyád egy helyen";
                    // Meta description beállítása
                    $timeout(function () {
                        var metaDescription = document.querySelector('meta[name="description"]');
                        if (!metaDescription) {
                            metaDescription = document.createElement('meta');
                            metaDescription.name = "description";
                            document.getElementsByTagName('head')[0].appendChild(metaDescription);
                        }
                        metaDescription.content = "Minden hűségkártyád egy helyen. Mindig nálad, digitálisan a mobilodon.";
                    }, 0);
                },
                params: {
                    obj: null
                }
            })
            .state('appDownloadLanding', {
                url: "^/app-download-landing?cp&cm&cs&cu&h&e",
                onEnter: function ($window, $state) {
                    $window.document.title = "yalty | Minden hűségkártyád egy helyen";
                }
            })
            .state('index_HU.discount', {
                url: "^/discountHU",
                templateUrl: '../views/discount_HU.html?v=20200251150',
                onEnter: function ($window) { $window.document.title = "yalty | Minden hűségkártyád egy helyen"; },
                resolve: {
                    getPAK: function ($http, API_PREFIX) {
                        return $http({ method: 'GET', url: API_PREFIX.url + '/etc/getPAK' }).then(function (result) {
                            return result.data;
                        }, function (result) { });
                    },
                    getAllYaltyCitys: function ($http, API_PREFIX, GoogleAnalyticsService) {
                        return $http({ method: 'GET', url: API_PREFIX.url + '/etc/getListOfActiveCitiesWebB2C' }).then(function (result) {
                            if (result.data.errorCode == 0) {
                                GoogleAnalyticsService.sendDataToGA("/HU/felhasználói/kedvezmények/yalty_városok_lekérdezése_sikeres",
                                    "HU Kedvezmények - Város lekérdezés sikeres")
                                return result.data;
                            } else {
                                GoogleAnalyticsService.sendDataToGA("/HU/felhasználói/kedvezmények/yalty_városok_lekérdezése_sikertelen",
                                    "HU Kedvezmények - Város lekérdezés sikertelen")
                                return result.data.errorCode;
                            }
                        }, function (result) {
                            GoogleAnalyticsService.sendDataToGA("/HU/felhasználói/kedvezmények/yalty_városok_lekérdezése_sikertelen",
                                "HU Kedvezmények - Város lekérdezés sikertelen")
                        });
                    },
                    getAllYaltyCategory: function ($http, API_PREFIX, GoogleAnalyticsService) {
                        return $http({ method: 'GET', url: API_PREFIX.url + '/etc/getAllYaltyPromoCategoryWebB2C' }).then(function (result) {
                            if (result.data.errorCode == 0) {
                                GoogleAnalyticsService.sendDataToGA("/HU/felhasználói/kedvezmények/promóciós_kategóriák_lekérdezése_sikeres",
                                    "HU Kedvezmények - Promóciós kategóriák lekérdezés sikeres")
                                return result.data;
                            } else {
                                GoogleAnalyticsService.sendDataToGA("/HU/felhasználói/kedvezmények/promóciós_kategóriák_lekérdezése_sikertelen",
                                    "HU Kedvezmények - Promóciós kategóriák lekérdezés sikertelen")
                                return result.data.errorCode;
                            }
                        }, function (result) {
                            GoogleAnalyticsService.sendDataToGA("/HU/felhasználói/kedvezmények/promóciós_kategóriák_lekérdezése_sikertelen",
                                "HU Kedvezmények - Promóciós kategóriák lekérdezés sikertelen")
                        });
                    }
                },
                controller: function ($scope, getAllYaltyCitys, getAllYaltyCategory, getPAK) {
                    $scope.varosok = getAllYaltyCitys.listOfActiveCities;
                    $scope.kategoriak = getAllYaltyCategory.allYaltyPromoCategory;
                    $scope.PAKtoken = getPAK.public_token;
                }
            })
            .state('appshare', {
                url: "/appshare?id&lang",
                templateUrl: '../views/appshare.html?v=202304141345'
            })
            .state('activateUser', {
                url: "/service/activateUser?activate&lang",
                templateUrl: '../views/activation.html?v=202406201322'
            })
            .state('loyaltyCardRegistration68', {
                url: "/service/loyaltyCardRegistration68?lname&fname&email&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistration68.html?v=202505151415'
            })
            .state('loyaltyCardRegistration69', {
                url: "/service/loyaltyCardRegistration69?lname&fname&email&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistration69.html?v=202505151415'
            })
            .state('loyaltyCardRegistration70', {
                url: "/service/loyaltyCardRegistration70?lname&fname&email&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistration70.html?v=202505151415'
            })
            .state('loyaltyCardRegistration71', {
                url: "/service/loyaltyCardRegistration71?lname&fname&email&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistration71.html?v=202505151415'
            })
            .state('loyaltyCardRegistration72', {
                url: "/service/loyaltyCardRegistration72?lname&fname&email&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistration72.html?v=202505151415'
            })
            .state('loyaltyCardRegistration80', {
                url: "/service/loyaltyCardRegistration80?lname&fname&email&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistration80.html?v=202505151415'
            })
            .state('loyaltyCardRegistration81', {
                url: "/service/loyaltyCardRegistration81?lname&fname&email&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistration81.html?v=202505151415'
            })
            .state('loyaltyCardRegistration82', {
                url: "/service/loyaltyCardRegistration82?lname&fname&email&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistration82.html?v=202505151415'
            })
            .state('loyaltyCardRegistration83', {
                url: "/service/loyaltyCardRegistration83?lname&fname&email&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistration83.html?v=202505151415'
            })
            .state('loyaltyCardRegistrationDonPepe', {
                url: "/service/loyaltyCardRegistrationDonPepe?lname&fname&email&birthday&lang&insid&token",
                templateUrl: '../views/loyaltyCardRegistrationDonPepe.html?v=202505071613',
                /* 2025.04.09.MP legördülő listás város választóhoz szükséges adat lekérések
                resolve: {
                    getCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 3, countryName: 'Magyarország' });
                    }
                },
                controller: function ($scope, getCities) {
                    $scope.listOfCities = getCities.listOfCities ? getCities.listOfCities : [];
                }
                */
            })
            .state('resetUserPassword', {
                url: "/service/resetUserPassword?reset&lang",
                templateUrl: '../views/activation.html?v=202304141345'
            })
            .state('accountDeletionRequest', {
                url: "/service/accountDeletionRequest",
                templateUrl: '../views/accountDeletionRequest.html?v=202405300929'
            })
            .state('resetPartnerUserPassword', {
                url: "/service/resetPartnerUserPassword?reset",
                templateUrl: '../views/activation.html?v=202304141345'
            })
            .state('activatePartnerUser', {
                url: "/service/activatePartnerUser?activate",
                templateUrl: '../views/activation.html?v=202304141345'
            })
            .state('activateMasterUser', {
                url: "/service/activateMasterUser",
                templateUrl: '../views/activation.html?v=202304141345'
            })
            .state('finallyPartnerRemove', {
                url: "/service/deletePartner?delete",
                templateUrl: '../views/finallyDelete.html?v=202402081402'
            })
            .state('endOfSubscription', {
                url: "/service/subscription-expired",
                templateUrl: '../views/activation.html?v=202304141345'
            })
            .state('resumeOrCancelTransaction', {
                url: "/service/active-transaction",
                templateUrl: '../views/activation.html?v=202304141345'
            })
            .state('home', {
                url: "/partner/home",
                templateUrl: '../views/header.html?v=202505190932',
                controller: 'AppCtrl'
            })
            .state('home.welcome', {
                url: "/welcome",
                templateUrl: '../views/welcome.html?v=202411251120',
                onEnter: function ($window, $timeout) {
                    // Title beállítása 
                    $window.document.title = "yalty | Partneri oldal";
                },
                resolve: {
                    currentState: function () {
                        return "KEZDŐLAP";
                    }
                },
                controller: function ($scope, $cookies, currentState) {
                    $scope.firstName = $cookies.get('firstName');
                    $scope.currentState = currentState;
                    $scope.partnerType = $cookies.get('partnerType');
                }
            })
            .state('home.cashing', {
                url: "/redeem-handling",
                templateUrl: '../views/cashing.html?v=202506041227',
                resolve: {
                    currentState: function () {
                        return "BEVÁLTÁSOK KEZELÉSE";
                    },
                    getDataForFiltering: function ($http, API_PREFIX) {
                        return $http.get(API_PREFIX.url + "/partner/getDataForCompanyStoreFiltering").then((result) => {
                            if (result.data.errorCode == 0) {
                                return result.data.allDataForCompanyStoreFiltering;
                            } else {
                                return result.data.errorCode;
                            }
                        })
                    }
                },
                controller: function ($scope, currentState, getDataForFiltering) {
                    $scope.currentState = currentState;
                    $scope.isPhoneOrOnlineOrderAvailableFilter = false;
                    $scope.dataForFiltering = getDataForFiltering;
                    for (let data of $scope.dataForFiltering) {
                        if (data.isPhoneOrOnlineOrderAvailable == 1) {
                            $scope.isPhoneOrOnlineOrderAvailableFilter = true;
                        }
                    }
                }
            })
            .state('cashRegisterCashing', {
                url: "/redeem-handling-minimal-display",
                templateUrl: '../views/cashing.html?v=202506041227',
                resolve: {
                    currentState: function () {
                        return "BEVÁLTÁSOK KEZELÉSE";
                    },
                    getDataForFiltering: function ($http, API_PREFIX) {
                        return $http.get(API_PREFIX.url + "/partner/getDataForCompanyStoreFiltering").then((result) => {
                            if (result.data.errorCode == 0) {
                                return result.data.allDataForCompanyStoreFiltering;
                            } else {
                                return result.data.errorCode;
                            }
                        })
                    }
                },
                controller: function ($scope, currentState, getDataForFiltering) {
                    $scope.currentState = currentState;
                    $scope.isPhoneOrOnlineOrderAvailableFilter = false;
                    $scope.dataForFiltering = getDataForFiltering;
                    for (let data of $scope.dataForFiltering) {
                        if (data.isPhoneOrOnlineOrderAvailable == 1) {
                            $scope.isPhoneOrOnlineOrderAvailableFilter = true;
                        }
                    }
                }
            })
            .state('home.kupon1', {
                url: "/coupons-info",
                templateUrl: '../views/kuponGuide.html?v=202304271049',
                resolve: {
                    currentState: function () {
                        return "KUPONOK";
                    },
                    currentSubState: function () {
                        return "Ismertető";
                    }
                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('home.kupon2', {
                url: "/coupons-our-coupons/:couponId",
                templateUrl: '../views/kupon.html?v=202401241259',
                resolve: {
                    getCoupons: function ($http, API_PREFIX, GoogleAnalyticsService) {
                        return $http({ method: 'GET', url: API_PREFIX.url + '/coupon/getAllCouponsListViewData' }).then(function (result) {
                            if (result.data.errorCode == 0) {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/kuponok_kuponjaink/kuponlista_lekérdezése_sikeres",
                                    "HU Partner [PRIVÁT] - Kuponjaink oldal - Kuponlista lekérdezés sikeres")
                                return result.data;
                            } else {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/kuponok_kuponjaink/kuponlista_lekérdezése_sikertelen",
                                    "HU Partner [PRIVÁT] - Kuponjaink oldal - Kuponlista lekérdezés sikertelen")
                                return result.data.errorCode;
                            }
                        }, function () {
                            GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/kuponok_kuponjaink/kuponlista_lekérdezése_sikertelen",
                                "HU Partner [PRIVÁT] - Kuponjaink oldal - Kuponlista lekérdezés sikertelen")
                        });
                    },
                    currentState: function () {
                        return "KUPONOK";
                    },
                    currentSubState: function () {
                        return "Kuponjaink";
                    }
                },
                controller: function ($scope, getCoupons, currentState, currentSubState) {
                    $scope.allCoupon = getCoupons.allCouponsListViewData;
                    $scope.allCompStores = getCoupons.companyData;
                    $scope.compNamePromo = getCoupons.companyData[0].compNamePromo;
                    if (getCoupons.companyData[0].partnerRedeemHandlingStatus == 1) {
                        $scope.isRedeemPartnerResponseRequired = true;
                    } else {
                        $scope.isRedeemPartnerResponseRequired = false;
                    }
                    $scope.promoCategories = getCoupons.promoCategories;
                    $scope.companyLogo = getCoupons.companyData[0].compLogoImgURL;
                    $scope.mainPromoCategory = getCoupons.companyData[0].mainPromoCategory;
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.isTranslation_EN_Enabled = getCoupons.companyData[0].isTranslation_EN_Enabled
                    $scope.partnerData = {}
                    $scope.partnerData.translatedCompNamePromo = getCoupons.companyData[0].compNamePromo_EN
                }
            })
            .state('home.huseg1', {
                url: "/loyalty-cards-info",
                templateUrl: '../views/loyaltyGuide.html?v=202304271049',
                resolve: {
                    currentState: function () {
                        return "HŰSÉGKÁRTYÁK";
                    },
                    currentSubState: function () {
                        return "Ismertető";
                    }
                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('home.loyaltyCardsDashboard', {
                url: "/loyalty-cards-dashboard",
                component: 'loyaltyCardYaltyDashboard'
            })
            .state('home.loyaltyCardsTimeSeriesStats', {
                url: "/loyalty-cards-time-series-stats",
                component: 'loyaltyCardYaltyTimeSeriesStats'
            })
            .state('home.loyaltyCardsUserStats', {
                url: "/loyalty-cards-user-stats",
                component: 'loyaltyCardYaltyUserStats'
            })
            .state('home.huseg2', {
                url: "/loyalty-card-stamp-cards",
                params: { loyaltyCardId: 0 },
                templateUrl: '../views/huseg.html?v=202506020927',
                resolve: {
                    getLoyaltys: function ($http, API_PREFIX, GoogleAnalyticsService) {
                        return $http({ method: 'POST', url: API_PREFIX.url + '/loyaltyCard/getAllLoyaltyCardStampListViewData', data: { getFilteredLCsByMarketingPackage: false } }).then(function (result) {
                            if (result.data.errorCode == 0) {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/hűségkártyáink/hűségkártyalista_lekérdezése_sikeres",
                                    "HU Partner [PRIVÁT] - Hűségkártyáink oldal - Hűségkártya lista lekérdezése sikeres")
                                return result.data;
                            } else {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/hűségkártyáink/hűségkártyalista_lekérdezése_sikertelen",
                                    "HU Partner [PRIVÁT] - Hűségkártyáink oldal - Hűségkártya lista lekérdezése sikertelen")
                                return result.data.errorCode;
                            }
                        }, function () {
                            GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/hűségkártyáink/hűségkártyalista_lekérdezése_sikertelen",
                                "HU Partner [PRIVÁT] - Hűségkártyáink oldal - Hűségkártya lista lekérdezése sikertelen")
                        });
                    },
                    currentState: function () {
                        return "HŰSÉGKÁRTYÁK";
                    },
                    currentSubState: function () {
                        return "Hűségkártyáink";
                    }
                },
                controller: function ($scope, currentState, currentSubState, getLoyaltys) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.allLoyaltyCard = getLoyaltys.allLoyaltyCardsListViewData;
                    let activeCount = 0, stopCardIssuingCount = 0;
                    for (let card of $scope.allLoyaltyCard) {
                        if (card.loyaltyCardPromoStatus == 1) {
                            activeCount++;
                        } else if (card.loyaltyCardPromoStatus == 2) {
                            stopCardIssuingCount++;
                        }
                    }
                    $scope.stopCardIssuingCount = stopCardIssuingCount;
                    $scope.activeCount = activeCount;
                }
            })
            .state('home.huseg4', {
                url: "/loyalty-cards-messaging",
                templateUrl: '../views/partnerPushNotifications.html?v=202410311122',
                resolve: {
                    currentState: function () {
                        return "HŰSÉGKÁRTYÁK";
                    },
                    currentSubState: function () {
                        return "Üzenetküldés";
                    }
                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('home.huseg3', {
                url: "/generate-marketing-bundle",
                params: { loyaltyCardId: 0 },
                templateUrl: '../views/marketingPackages.html?v=202402121136',
                resolve: {
                    getLoyaltys: function ($http, API_PREFIX, $cookies, GoogleAnalyticsService) {
                        return $http({ method: 'POST', url: API_PREFIX.url + '/loyaltyCard/getAllLoyaltyCardStampListViewData', data: { getFilteredLCsByMarketingPackage: $cookies.get('adminUserType') == null } })
                            .then(result => {
                                if (result.data.errorCode == 0) {
                                    GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/marketing_csomagok/hűségkártyalista_lekérdezése_sikeres",
                                        "HU Partner [PRIVÁT] - Hűségkártyák marketing csomagok oldal - Hűségkártya lista lekérdezése sikeres")
                                    return result.data;
                                } else {
                                    GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/marketing_csomagok/hűségkártyalista_lekérdezése_sikertelen",
                                        "HU Partner [PRIVÁT] - Hűségkártyák marketing csomagok oldal - Hűségkártya lista lekérdezése sikertelen")
                                    return result.data.errorCode;
                                }
                            })
                            .catch(err => { })
                    },
                    currentState: function () {
                        return "HŰSÉGKÁRTYÁK";
                    },
                    currentSubState: function () {
                        return "Marketing csomagok";
                    }
                },
                /*controller: 'marketingPackagesCtrl'*/
                controller: function ($scope, currentState, currentSubState, getLoyaltys) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.allLoyaltyCard = getLoyaltys.allLoyaltyCardsListViewData;
                    let activeCount = 0, stopCardIssuingCount = 0;
                    for (let card of $scope.allLoyaltyCard) {
                        if (card.loyaltyCardPromoStatus == 1) {
                            activeCount++;
                        } else if (card.loyaltyCardPromoStatus == 2) {
                            stopCardIssuingCount++;
                        }
                    }
                    $scope.stopCardIssuingCount = stopCardIssuingCount;
                    $scope.activeCount = activeCount;
                }
            })
            .state('home.huseg5', {
                url: "/loyalty-card-our-cards",
                params: { loyaltyCardId: 0 },
                templateUrl: '../views/loyaltyCards.html?v=202503171132',
                resolve: {
                    getLoyaltys: function ($http, API_PREFIX, GoogleAnalyticsService) {
                        return $http({ method: 'GET', url: API_PREFIX.url + '/loyaltyCard/getAllLoyaltyCardsListViewData' }).then(function (result) {
                            if (result.data.errorCode == 0) {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/hűségkártyáink/hűségkártyalista_lekérdezése_sikeres",
                                    "HU Partner [PRIVÁT] - Hűségkártyáink oldal - Hűségkártya lista lekérdezése sikeres")
                                return result.data;
                            } else {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/hűségkártyáink/hűségkártyalista_lekérdezése_sikertelen",
                                    "HU Partner [PRIVÁT] - Hűségkártyáink oldal - Hűségkártya lista lekérdezése sikertelen")
                                return result.data.errorCode;
                            }
                        }, function () {
                            GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/hűségkártyáink/hűségkártyalista_lekérdezése_sikertelen",
                                "HU Partner [PRIVÁT] - Hűségkártyáink oldal - Hűségkártya lista lekérdezése sikertelen")
                        });
                    },
                    currentState: function () {
                        return "HŰSÉGKÁRTYÁK";
                    },
                    currentSubState: function () {
                        return "Törzskártyáink";
                    }
                },
                controller: function ($scope, currentState, currentSubState, getLoyaltys) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.allLoyaltyCard = getLoyaltys.allLoyaltyCardsListViewData;
                    let activeCount = 0, stopCardIssuingCount = 0;
                    for (let card of $scope.allLoyaltyCard) {
                        if (card.loyaltyCardPromoStatus == 1) {
                            activeCount++;
                        } else if (card.loyaltyCardPromoStatus == 2) {
                            stopCardIssuingCount++;
                        }
                    }
                    $scope.stopCardIssuingCount = stopCardIssuingCount;
                    $scope.activeCount = activeCount;
                }
            })
            .state('home.statistic', {
                url: "/statistic",
                templateUrl: '../views/statistics.html',
                resolve: {
                    currentState: function () {
                        return "STATISZTIKA";
                    }
                },
                controller: function ($scope, currentState) {
                    $scope.currentState = currentState;
                }
            })
            .state('home.analitics', {
                url: "/analitics",
                templateUrl: '../views/analitics.html',
                resolve: {
                    currentState: function () {
                        return "ANALITIKA";
                    }
                },
                controller: function ($scope, currentState) {
                    $scope.currentState = currentState;
                }
            })
            .state('home.campaign', {
                url: "/campaign",
                templateUrl: '../views/campaign.html',
                resolve: {
                    currentState: function () {
                        return "KAMPÁNY";
                    }
                },
                controller: function ($scope, currentState) {
                    $scope.currentState = currentState;
                }
            })
            .state('home.bills', {
                url: "/bills",
                templateUrl: '../views/bills.html',
                resolve: {
                    currentState: function () {
                        return "SZÁMLÁK";
                    }
                },
                controller: function ($scope, currentState) {
                    $scope.currentState = currentState;
                }
            })
            .state('home.loyaltyCardYaltyStampsAndRedeems', {
                url: "/loyaltycardyalty-stamps-and-redeems",
                templateUrl: '../views/loyaltyCardYaltyStampsAndRedeems.html?v=202502241018',
                resolve: {
                    currentState: function () {
                        return "KIMUTATÁSOK";
                    },
                    currentSubState: function () {
                        return "Pecsét/jutalom kiadások összesítése";
                    }
                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('home.loyaltyCardYaltyRedeemsHistory', {
                url: "/loyaltycardyalty-redeems-history",
                templateUrl: '../views/loyaltyCardYaltyRedeemsHistory.html?v=202502241018',
                resolve: {
                    currentState: function () {
                        return "KIMUTATÁSOK";
                    },
                    currentSubState: function () {
                        return "Pecsét/jutalom kiadások története";
                    }
                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('home.partnerModHistory', {
                url: "/partner-activity-history",
                templateUrl: '../views/partnerModHistory.html?v=202502241018',
                resolve: {
                    currentState: function () {
                        return "KIMUTATÁSOK";
                    },
                    currentSubState: function () {
                        return "Partneri módosítás történet";
                    }
                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('home.settings', {
                url: "/partner-registration-data",
                templateUrl: '../views/settings.html?v=202505151415',
                resolve: {
                    getCompData: function ($http, API_PREFIX, GoogleAnalyticsService) {
                        return $http.post(API_PREFIX.url + '/company/getCompanyPartnerViewData').then(function (result) {
                            if (result.data.errorCode == 0) {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/partneri_adatok/cégadatok_lekérdezése_sikeres",
                                    "HU Partner [PRIVÁT] - Partneri adatok oldal - Sikeres cégadat lekérdezés")
                                return result.data;
                            } else {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/partneri_adatok/cégadatok_lekérdezése_sikertelen",
                                    "HU Partner [PRIVÁT] - Partneri adatok oldal - Sikertelen cégadat lekérdezés")
                                return result.data.errorCode;
                            }
                        }, function () {
                            GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/partneri_adatok/cégadatok_lekérdezése_sikertelen",
                                "HU Partner [PRIVÁT] - Partneri adatok oldal - Sikertelen cégadat lekérdezés")
                        });
                    },
                    getCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 3, countryName: 'Magyarország' });
                    },
                    currentState: function () {
                        return "PARTNERI ADATOK";
                    },
                },
                controller: function ($scope, currentState, getCompData, getCities, $cookies) {
                    $scope.listOfCities = getCities.listOfCities ? getCities.listOfCities : [];
                    $scope.currentState = currentState;
                    $scope.compData = getCompData.companyPartner[0];
                    if (getCompData.companyPartner[0] != null) {
                        $cookies.put('userCompany', getCompData.companyPartner[0].compNamePromo);
                        $scope.$parent.userCompany = getCompData.companyPartner[0].compNamePromo;
                        $cookies.put('compLogo', getCompData.companyPartner[0].compLogoImgURL);
                        $scope.$parent.userCompLogo = getCompData.companyPartner[0].compLogoImgURL;
                    }
                    $scope.partnerUserData = getCompData.userData[0];
                    $scope.promotionCategories = getCompData.promoCategories;
                }
            })
            .state('home.users', {
                url: "/partner-user-accounts",
                templateUrl: '../views/userAccounts.html?v=202505151415',
                resolve: {
                    getCompData: function ($http, API_PREFIX, GoogleAnalyticsService) {
                        return $http.post(API_PREFIX.url + '/company/getCompanyPartnerViewData').then(function (result) {
                            if (result.data.errorCode == 0) {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/partneri_adatok/cégadatok_lekérdezése_sikeres",
                                    "HU Partner [PRIVÁT] - Partneri adatok oldal - Sikeres cégadat lekérdezés")
                                return result.data;
                            } else {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/partneri_adatok/cégadatok_lekérdezése_sikertelen",
                                    "HU Partner [PRIVÁT] - Partneri adatok oldal - Sikertelen cégadat lekérdezés")
                                return result.data.errorCode;
                            }
                        }, function () {
                            GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/partneri_adatok/cégadatok_lekérdezése_sikertelen",
                                "HU Partner [PRIVÁT] - Partneri adatok oldal - Sikertelen cégadat lekérdezés")
                        });
                    },
                    getDataForFiltering: function ($http, API_PREFIX) {
                        return $http.get(API_PREFIX.url + "/partner/getDataForCompanyStoreFiltering").then((result) => {
                            if (result.data.errorCode == 0) {
                                return result.data.allDataForCompanyStoreFiltering;
                            } else {
                                return result.data.errorCode;
                            }
                        })
                    },
                    getUserData: function (UserAccountService) {
                        return UserAccountService.getUserData(null);
                    },
                    getUsers: function (UserAccountService) {
                        return UserAccountService.getUsers();
                    },
                    currentState: function () {
                        return "PARTNERI ADATOK";
                    },
                    currentSubState: function ($cookies) {
                        if ($cookies.get('authorizationLevel') == 'redeemer') {
                            return "Felhasználói fiókom";
                        } else {
                            return "Felhasználói fiókok";
                        }
                    }
                },
                controller: function ($scope, getUsers, getUserData, currentState, currentSubState, getCompData, getDataForFiltering) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.compData = getCompData.companyPartner[0];
                    $scope.allUser = getUsers ? getUsers : [];
                    $scope.userData = getUserData;
                    $scope.isPhoneOrOnlineOrderAvailableFilter = false;
                    $scope.dataForFiltering = getDataForFiltering;
                    for (let data of $scope.dataForFiltering) {
                        if (data.isPhoneOrOnlineOrderAvailable == 1) {
                            $scope.isPhoneOrOnlineOrderAvailableFilter = true;
                        }
                    }
                }
            })
            .state('home.settingsActivation', {
                url: "/settingsActivation",
                templateUrl: '../views/activateUserAccount.html?v=202505151415',
                resolve: {
                    currentState: function () {
                        return "PARTNERI ADATOK";
                    },
                    currentSubState: function () {
                        return "Felhasználói fiókom";
                    }
                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('home.stores', {
                url: "/partner-company-stores",
                templateUrl: '../views/companyStores.html?v=202502171723',
                resolve: {
                    getStores: function ($http, API_PREFIX, GoogleAnalyticsService) {
                        return $http({ method: 'POST', url: API_PREFIX.url + '/company/getAllCompanyStoreListViewData', body: {} }).then(function (result) {
                            if (result.data.errorCode == 0) {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/üzletek/üzletlista_lekérdezés_sikeres",
                                    "HU Partner [PRIVÁT] - Üzletek oldal - Sikeres üzletlista lekérdezés")
                                return result.data;
                            } else {
                                GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/üzletek/üzletlista_lekérdezés_sikertelen",
                                    "HU Partner [PRIVÁT] - Üzletek oldal - Sikertelen üzletlista lekérdezés")
                                return result.data.errorCode;
                            }
                        }, function () {
                            GoogleAnalyticsService.sendDataToGA("/HU/partneri/privat/üzletek/üzletlista_lekérdezés_sikertelen",
                                "HU Partner [PRIVÁT] - Üzletek oldal - Sikertelen üzletlista lekérdezés")
                        });
                    },
                    getCompData: function (StoreService) {
                        return StoreService.modifyStore(0);
                    },
                    getCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 3, countryName: 'Magyarország' });
                    },
                    getYaltyCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 1, countryName: 'Magyarország' });
                    },
                    currentState: function () {
                        return "PARTNERI ADATOK";
                    },
                    currentSubState: function () {
                        return "Üzletek";
                    }
                },
                controller: function ($scope, $cookies, getStores, getCompData, getCities, getYaltyCities, currentState, currentSubState) {
                    $scope.listOfCities = getCities.listOfCities;
                    $scope.listOfYaltyCities = getYaltyCities.listOfCities;
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    var storesData = getStores;
                    $scope.allStores = storesData.companyStoreListViewData;
                    $scope.allPromotions = storesData.couponsAndLoyaltyCardData;
                    $scope.hasActiveOrDraft = storesData.hasActiveOrDraft;
                    $scope.dataCompany = getCompData;
                    $scope.partnerType = $cookies.get('partnerType');
                }
            })
            .state('home.aggregateStores', {
                url: "/aggregate-partner-company-stores",
                component: 'aggregateStores'
            })
            .state('home.subscription', {
                url: "/partner-subscription?prefillPaymentDetails",
                templateUrl: '../views/subscriptions.html?v=202304271049',
                resolve: {
                    currentState: function () {
                        return "ELŐFIZETÉS";
                    }
                },
                controller: function ($scope, currentState) {
                    $scope.currentState = currentState;
                }
            })
            .state('unsubscribe', {
                url: "/partner/email-unsubscribe?cm&id&as&email",
                templateUrl: '../views/unsubscribeLanding.html?v=201908062115',
                controller: function ($scope, AuthService) {
                    AuthService.unsubscribe().then((result) => {
                        $scope.unsubscribeSuccesful = true
                    }, function () { })
                }
            })
            .state('payment-redirect-landing', {
                url: "^/subscription-payment-redirect-landing?transactionId",
                templateUrl: '../views/paymentRedirect.html?v=201910041730',
                controller: function ($scope, $location, AuthService, $cookies) {
                    AuthService.logout('noredirect')
                    let setStatus = (status) => {
                        if (status == 1) {
                            $scope.status = 'Sikeres fizetés! Yalty előfizetési csomagját sikeresen aktiváltuk :) <br><br>'
                            $scope.status += $cookies.get('isMasterUserActivated') == 'false' ?
                                '<b>Mielőtt belépne a partneri oldalakra, kérjük aktiválja az email címét.</b><br><br>' +
                                'Regisztrációkor más email címet adott meg, mint amire az emailt kiküldtük. ' +
                                'Ilyenkor ezt az új email címét első lépésben aktiválnia szükséges. ' +
                                'A megadott, új címére kiküldtünk egy aktivációs emailt. ' +
                                'Az emailben található aktivációs linkre kattintva tudja a fiókját aktiválni. ' +
                                'Ezután már rendben be tud majd lépni email címével és jelszavával a partneri oldalakra.<br><br>' +
                                'Ha levelünket nem találná, kérjük ellenőrizze levelezője SPAM mappáját is. ' +
                                'Az aktivációs levél újbóli kiküldését úgy kérheti, ha a belépés oldalon belép. ' +
                                'Ilyenkor, amíg még nem aktivált a fiókja, egy hasonló üzenetet jelenítünk meg. ' +
                                'Az üzenet mellett találja majd a levél újrakiküldés gombot.' :
                                'Kérjük lépjen be partneri oldalára a Yalty használatához.'
                        } else if (status == 10) {
                            $scope.status = 'Sikertelen fizetés! Partneri fizetés megszakítás, partnerünk visszalépett a fizetés véglegesítése előtt.'
                        } else if (status == 11) {
                            $scope.status = 'Sikertelen fizetés. Ez egy, a Barion által korábban nem használt hibakód.'
                        } else if (status == 12) {
                            $scope.status = 'Sikertelen fizetés! Lejárt a Barion fizetési idő a fizetés felhasználói véglegesítése előtt.'
                        } else if (status == 20) {
                            $scope.status = 'Sikertelen fizetés! A Bariontól nem érkezett válasz az elmúlt fél órában.'
                        }
                        $cookies.remove('isMasterUserActivated')
                    }
                    let checkPayment = () => {
                        AuthService.checkPaymentStatus().then((result) => {
                            if (result.status != 0) {
                                if (result.errorCode == 0) {
                                    setStatus(result.status)
                                    clearInterval(checkPaymentStatus)
                                } else {
                                    clearInterval(checkPaymentStatus)
                                    AuthService.logout()
                                }
                            }
                        }, function () { })
                    }
                    checkPayment()
                    let checkPaymentStatus = setInterval(checkPayment, 5000)
                    $scope.login = function () {
                        document.location = $location.protocol() + "://" + location.host + "/partnerHU/loginHU"
                        AuthService.logout()
                    }
                }
            })
            .state('home.preRegistrationLanding', {
                url: "^/service/registerCompany?preview",
                templateUrl: '../views/preRegistrationLanding.html?v=202410181518',
                resolve: {
                    currentState: function () {
                        return "BEÁLLÍTÁSOK";
                    },
                    currentSubState: function () {
                        return "Adatok megadása";
                    }
                }
            })
            .state('home.newPreRegistrationLanding', {
                url: "^/service/viewInfo?preview&e",
                templateUrl: '../views/preRegistrationLanding.html?v=202305310722',
                resolve: {
                    currentState: function () {
                        return "BEÁLLÍTÁSOK";
                    },
                    currentSubState: function () {
                        return "Adatok megadása";
                    }
                },
                controller: function ($scope, $location) {
                    $scope.e = $location.search().e;
                }
            })
            .state('home.preRegSubscription', {
                url: "^/service/partner-subscription?preview&e",
                templateUrl: '../views/preRegSubscriptions.html?v=201910301320',
                resolve: {
                    currentState: function () {
                        return "ELŐFIZETÉSEK";
                    }
                },
                controller: function ($scope, currentState) {
                    $scope.currentState = currentState;
                }
            })
            .state('home.preRegistration', {
                url: "^/service/register?preview&e",
                templateUrl: '../views/settings.html?v=202505151415',
                resolve: {
                    currentState: function () {
                        return "PARTNERI REGISZTRÁCIÓ";
                    },
                    getPromoCatergories: function ($http, API_PREFIX) {
                        return $http.get(API_PREFIX.url + '/etc/getAllYaltyPromoCategory').then(function (result) {
                            if (result.data.errorCode == 0) {
                                return result.data;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    },
                    getCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 3, countryName: 'Magyarország' });
                    }
                },
                controller: function ($scope, currentState, getCities, getPromoCatergories) {
                    $scope.listOfCities = getCities.listOfCities;
                    var promoCategories = [];
                    for (var item in getPromoCatergories.allYaltyPromoCategory) {
                        promoCategories[item] = {};
                        promoCategories[item].id = getPromoCatergories.allYaltyPromoCategory[item].id;
                        promoCategories[item].promoCategoryName = getPromoCatergories.allYaltyPromoCategory[item].kategorianev;
                    }
                    $scope.promotionCategories = promoCategories;
                    $scope.currentState = currentState;
                }
            })
            .state('adminLogin', {
                url: "^/yaltyadmin738",
                templateUrl: '../views/adminLogin.html?v=202410281520',
                onEnter: function ($window) { $window.document.title = "yalty | Admin oldal bejelentkezés"; }
            })
            .state('adminPages', {
                url: "^/yaltyadmin738/home",
                templateUrl: '../views/adminHome.html?v=202404170641',
                onEnter: function ($window) { $window.document.title = "yalty | Admin oldal"; }
            })
            .state('adminPages.users', {
                url: "^/yaltyadmin738/users",
                templateUrl: '../views/adminUsers.html?v=202505151415',
                onEnter: function ($window) { $window.document.title = "yalty | Admin oldal"; },
                resolve: {
                    currentState: function () {
                        return "YALTY ADMIN FELHASZNÁLÓ LÉTREHOZÁSA";
                    },
                },
                controller: function ($scope, currentState) {
                    $scope.currentState = currentState;
                }
            })
            .state('adminPages.managingRegisteredPartners', {
                url: "^/yaltyadmin738/managingRegisteredPartners",
                templateUrl: '../views/adminManagingRegisteredPartners.html?v=202503030953',
                resolve: {
                    currentState: function () {
                        return "REGISZTRÁLT PARTNEREK KEZELÉSE";
                    },
                    getYAdminUserList: function ($http, API_PREFIX) {
                        let inputParameters = {};
                        inputParameters.salesType = 2;
                        return $http.post(API_PREFIX.url + '/yaltyadmin/getYAdminUserList', inputParameters).then(function (result) {
                            if (result.data.errorCode == 0) {
                                return result.data.yAdminUsersData;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    }
                },
                controller: function ($scope, currentState, getYAdminUserList) {
                    $scope.currentState = currentState;
                    $scope.yaltyAdminUserList = getYAdminUserList;
                }
            })
            .state('adminPages.partnerPages', {
                url: "^/yaltyadmin738/partnerPages",
                templateUrl: '../views/partnerPages.html?v=202309081237',
                resolve: {
                    currentState: function () {
                        return "PARTNERI OLDALAK";
                    },
                    getAllPartnerList: function ($http, API_PREFIX) {
                        return $http.get(API_PREFIX.url + '/yaltyadmin/getAllPartnerList').then(function (result) {
                            if (result.data.errorCode == 0) {
                                return result.data;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    },
                },
                controller: function ($scope, currentState, getAllPartnerList) {
                    $scope.currentState = currentState;
                    $scope.allPartnerList = getAllPartnerList.partnerList;
                }
            })
            .state('adminPages.adminPotentialCompanies', {
                url: "^/yaltyadmin738/adminPotentialCompanies?mainId",
                templateUrl: '../views/adminPotentialCompanies.html?v=202506161145',
                resolve: {
                    currentState: function () {
                        return "HŰSÉGKÁRTYA POTENCIÁLIS CÉGEK";
                    },
                    currentSubState: function () {
                        return "Cégek kezelése";
                    },
                    getCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 3, countryName: 'Magyarország' });
                    },
                    getPromoCompProfiles: function ($http, API_PREFIX) {
                        return $http.get(API_PREFIX.url + '/yaltyadmin/getCompanyPreRegistrationPromoCompProfiles').then(function (result) {
                            if (result.data.errorCode == 0) {
                                let companyPreRegistrationPromoCompProfiles = result.data.companyPreRegistrationPromoCompProfiles;
                                companyPreRegistrationPromoCompProfiles.push({ id: 10000, compProfile: 'Egyéb', LCYPromotionName: null, LCYStampIconURLPrefix: null });
                                return companyPreRegistrationPromoCompProfiles;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    }
                },
                controller: function ($scope, currentState, getCities, getPromoCompProfiles, currentSubState) {
                    $scope.listOfCities = getCities.listOfCities;
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.promoCompProfiles = getPromoCompProfiles;
                }
            })
            .state('adminPages.adminPotCompPortfolio', {
                url: "^/yaltyadmin738/adminPotCompPortfolio",
                templateUrl: '../views/adminPotCompPortfolio.html?v=202410091700',
                resolve: {
                    currentState: function () {
                        return "HŰSÉGKÁRTYA POTENCIÁLIS CÉGEK";
                    },
                    currentSubState: function () {
                        return "Portfólió áttekintése";
                    },
                    getYaltyCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 1, countryName: 'Magyarország' });
                    },
                    getYAdminUserList: function ($http, API_PREFIX) {
                        let inputParameters = {};
                        inputParameters.salesType = 2;
                        return $http.post(API_PREFIX.url + '/yaltyadmin/getYAdminUserList', inputParameters).then(function (result) {
                            if (result.data.errorCode == 0) {
                                return result.data.yAdminUsersData;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    }
                },
                controller: function ($scope, currentState, currentSubState, getYaltyCities, getYAdminUserList) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.yaltyCities = getYaltyCities;
                    $scope.yaltyAdminUserList = getYAdminUserList;
                }
            })
            .state('adminPages.adminSalesLeaderboard', {
                url: "^/yaltyadmin738/adminSalesLeaderboard",
                templateUrl: '../views/adminSalesLeaderboard.html?v=202410091700',
                resolve: {
                    currentState: function () {
                        return "HŰSÉGKÁRTYA POTENCIÁLIS CÉGEK";
                    },
                    currentSubState: function () {
                        return "Sales leaderboard";
                    },
                    getYaltyCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 1, countryName: 'Magyarország' });
                    },
                    getYAdminUserList: function ($http, API_PREFIX) {
                        let inputParameters = {};
                        inputParameters.salesType = 2;
                        inputParameters.showsUpInSalesLeaderboard = 1;
                        return $http.post(API_PREFIX.url + '/yaltyadmin/getYAdminUserList', inputParameters).then(function (result) {
                            if (result.data.errorCode == 0) {
                                return result.data.yAdminUsersData;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    }
                },
                controller: function ($scope, currentState, currentSubState, getYaltyCities, getYAdminUserList) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.yaltyCities = getYaltyCities;
                    $scope.yaltyAdminUserList = getYAdminUserList;
                }
            })
            .state('adminPages.adminSalesMetrics', {
                url: "^/yaltyadmin738/adminSalesMetrics",
                templateUrl: '../views/adminSalesMetrics.html?v=202410091700',
                resolve: {
                    currentState: function () {
                        return "HŰSÉGKÁRTYA POTENCIÁLIS CÉGEK";
                    },
                    currentSubState: function () {
                        return "Sales mutatók";
                    },
                    getYaltyCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 1, countryName: 'Magyarország' });
                    },
                    getYAdminUserList: function ($http, API_PREFIX) {
                        let inputParameters = {};
                        inputParameters.salesType = 2;
                        inputParameters.showsUpInSalesLeaderboard = 1;
                        return $http.post(API_PREFIX.url + '/yaltyadmin/getYAdminUserList', inputParameters).then(function (result) {
                            if (result.data.errorCode == 0) {
                                return result.data.yAdminUsersData;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    }
                },
                controller: function ($scope, currentState, currentSubState, getYaltyCities, getYAdminUserList) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.yaltyCities = getYaltyCities;
                    $scope.yaltyAdminUserList = getYAdminUserList;
                }
            })
            .state('adminPages.preregistrations', {
                url: "^/yaltyadmin738/preregistrations/:preregistrationId",
                templateUrl: '../views/adminPreregistrations.html?v=202410221441',
                resolve: {
                    currentState: function () {
                        return "PARTNERI ELŐREGISZTRÁCIÓK";
                    },
                    currentSubState: function () {
                        return "Előregisztrációk listázása";
                    },
                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('adminPages.preregisterPartner', {
                url: "^/yaltyadmin738/preregisterPartner?preregId&mainId",
                templateUrl: '../views/adminPreregister.html?v=202505151415',
                resolve: {
                    currentState: function () {
                        return "PARTNERI ELŐREGISZTRÁCIÓK";
                    },
                    currentSubState: function () {
                        return "Új előregisztráció";
                    },
                    getPromoCompProfiles: function ($http, API_PREFIX) {
                        return $http.get(API_PREFIX.url + '/yaltyadmin/getCompanyPreRegistrationPromoCompProfiles').then(function (result) {
                            if (result.data.errorCode == 0) {
                                let companyPreRegistrationPromoCompProfiles = result.data.companyPreRegistrationPromoCompProfiles;
                                companyPreRegistrationPromoCompProfiles.push({ id: 10000, compProfile: 'Egyéb', LCYPromotionName: null, LCYStampIconURLPrefix: null });
                                return companyPreRegistrationPromoCompProfiles;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    }
                },
                controller: function ($scope, currentState, currentSubState, getPromoCompProfiles) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.promoCompProfiles = getPromoCompProfiles;
                }
            })
            .state('adminPages.invoicingSupport', {
                url: "^/yaltyadmin738/invoicingSupport/:transactionId",
                templateUrl: '../views/invoicingSupport.html?v=202501161700',
                resolve: {
                    currentState: function () {
                        return "EGYÉB";
                    },
                    currentSubState: function () {
                        return "Számlázás támogatás";
                    },

                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('adminPages.pushNotification', {
                url: "^/yaltyadmin738/pushNotification",
                component: 'pushNotification',
                resolve: {
                    currentState: function () {
                        return "EGYÉB";
                    },
                    currentSubState: function () {
                        return "Push üzenet kiküldése";
                    },

                }
            })
            .state('adminPages.sendingPartnerEmail', {
                url: "^/yaltyadmin738/sendingPartnerEmail",
                component: 'sendingPartnerEmail'
            })
            .state('adminPages.devEnvAccessReset', {
                url: "^/yaltyadmin738/devEnvAccessReset",
                templateUrl: '../views/devEnvAccessReset.html?v=202002061325',
                resolve: {
                    currentState: function () {
                        return "DEV EGYÉB";
                    },
                    currentSubState: function () {
                        return "Fejlesztői környzetek hozzáférés reset";
                    },

                },
                controller: function ($scope, currentState, currentSubState) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                }
            })
            .state('adminPages.userNumberStats', {
                url: "^/yaltyadmin738/userNumberStats",
                templateUrl: '../views/adminUserNumberStats.html?v=202502171722',
                resolve: {
                    currentState: function () {
                        return "STATISZTIKÁK";
                    },
                    currentSubState: function () {
                        return "FELHASZNÁLÓSZÁM";
                    },
                    getYaltyCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 1, countryName: 'Magyarország' });
                    },
                    getUserNumberStats: function ($http, API_PREFIX) {
                        let requestBody = {};
                        requestBody.period = 1;
                        requestBody.frontendTimezone = 'Central European Standard Time'
                        return $http.post(API_PREFIX.url + '/yaltyadmin/getUserNumberRegistrationStats', requestBody).then(function (result) {
                            if (result.data.errorCode == 0) {
                                return result.data.userNumberStats;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    }

                },
                controller: function ($scope, currentState, currentSubState, getYaltyCities, getUserNumberStats) {
                    $scope.currentState = currentState;
                    $scope.currentSubState = currentSubState;
                    $scope.yaltyCities = getYaltyCities
                    $scope.userNumberStats = getUserNumberStats;
                }
            })
            .state('adminPages.registerPartner', {
                url: "^/yaltyadmin738/registerPartner",
                templateUrl: '../views/settings.html?v=202505151415',
                resolve: {
                    currentState: function () {
                        return "PARTNER REGISZTRÁLÁSA";
                    },
                    getPromoCatergories: function ($http, API_PREFIX) {
                        return $http.get(API_PREFIX.url + '/etc/getAllYaltyPromoCategory').then(function (result) {
                            if (result.data.errorCode == 0) {
                                return result.data;
                            } else {
                                return result.data.errorCode;
                            }
                        });
                    },
                    getCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 3, countryName: 'Magyarország' });
                    }
                },
                controller: 'RegisterPartnerController'
            })
            .state('adminPages.yaltyCity', {
                url: "^/yaltyadmin738/yaltyCity",
                templateUrl: '../views/yaltyCitys.html?v=202502171723',
                resolve: {
                    currentState: function () {
                        return "YALTY VÁROSOK KEZELÉSE";
                    },
                    getCities: function (StoreService) {
                        return StoreService.getCities({ cityTypeSelector: 1, countryName: 'Magyarország' });
                    }
                },
                controller: 'YaltyCitysController'
            })
        $urlRouterProvider.otherwise('indexHU');
    })
    .run(function ($transitions, $rootScope, $mdToast, $mdDialog, $state, $window, AuthService, YaltyAuthService, RedeemService, API_PREFIX, $http, $location, $templateCache, $stateParams, $cookies, $anchorScroll, GoogleAnalyticsService) {
        let networkToast;
        window.addEventListener("offline", function () {
            if (document.getElementById('innerPartnerPageContainer')) {
                networkToast = $mdToast.simple()
                    .parent(document.getElementById('innerPartnerPageContainer'))
                    .textContent('Nincs internetkapcsolat.')
                    .position('top center')
                    .hideDelay(0)
                $mdToast.show(networkToast).then(function () { }).catch(function () { });
            }
            $rootScope.browserIsOnline = false;
            if ($state.current.name.includes("index_HU") || $state.current.name.includes("partner_HU")) {
                if ($rootScope.browserIsOnline === false) {
                    location.reload();
                    return
                }
            }
        }, false);
        window.addEventListener("online", function () {
            $rootScope.browserIsOnline = true;
            $mdToast.hide(networkToast)
        }, false);
        var confirm = $mdDialog.confirm()
            .title('Hamarosan lejár a belépési időkorlát, tovább szeretne böngészni az oldalon?')
            .textContent('Az oldal 12 órás időkorláttal van ellátva, 2 perccel a letelte előtt felugró ablakban jelezzük a hamarosan lejáró időkorlátot.')
            .ariaLabel('Session expired.')
            .ok('Igen!')
            .cancel('Nem');
        $rootScope.timerRunning = false;
        $rootScope.isConfirmDialogShow = false;
        document.addEventListener('visibilitychange', function (e) {
            if (document.visibilityState == "hidden") {
                $rootScope.visibilityState = document.visibilityState;
            } else if (document.visibilityState == "visible") {
                $rootScope.visibilityState = document.visibilityState;
            }
        });
        $transitions.onSuccess({ from: 'home.cashing' }, function (trans) {
            if (trans.to().name != 'home.cashing') {
                console.log('closeConn called from onBefore');
                RedeemService.closeConn('Navigation');
            }

        });
        $transitions.onBefore({ to: 'appDownloadLanding' }, function (trans) {
            /*var searchObject = $location.search();
            if (searchObject.exp) { 
                trans.abort()*/
            /*var win = window.open("about:blank", "_self");
            win.close();*/
            /*setTimeout(function(){ window.close(); }, 350);
            return false
        }*/
            $http.post(API_PREFIX.url + '/service/logAppDownloadLandings', {
                URLStringParameter: location.href.split("app-download-landing?")[1]
            }).then(function (result) {
                /*$location.search('exp', 'true');
                $location.replace();*/
                /*var win = window.open("about:blank", "_self");
                win.close();*/
            }, function () { });
            if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {
                setTimeout(function () { window.close(); }, 350);
                window.location.href = 'https://itunes.apple.com/app/apple-store/id1340457476?pt=118959301&ct=www.yalty.com_public_web_app_download&mt=8'
            } else if (navigator.userAgent.match(/android/i)) {
                setTimeout(function () { window.close(); }, 350);
                window.location.href = 'https://play.google.com/store/apps/details?id=com.yalty.yaltyapp&referrer=utm_source%3Dwww.yalty.com_public_web_app_download%26anid%3Dadmob'
            } else {
                trans.abort();
                $state.go("index_HU")
            }
        });
        $transitions.onBefore({ from: ['home', 'home.*'] }, function (trans) {
            if ($rootScope.isDataSheetModified == true) {
                var toState = trans.$to();
                var fromState = trans.from();
                trans.abort();
                let title, content
                if (fromState && fromState.name == 'home.huseg3') {
                    title = 'Biztosan elhagyja az oldalt?'
                    content = 'Egy vagy több mezőt módosított. Ha szeretné a módosításait véglegesíteni, akkor nyomjon a Mégsem gombra, majd a Generálás gombbal véglegesítse a marketing csomaghoz beállított jellemzőket.'
                } else {
                    title = 'Biztosan el szeretné hagyni az oldalt?'
                    content = 'Az adatlapon történt módosításai mentés nélkül elvesznek.'
                }
                var confirm = $mdDialog.confirm({
                    title: title,
                    textContent: content,
                    ariaLabel: 'Oldal elhagyás megerősítése',
                    ok: 'Igen',
                    cancel: 'Mégsem'
                })
                $mdDialog.show(confirm).then(function () {
                    $rootScope.isDataSheetModified = false;
                    $state.go(toState, trans['_targetState']['_params']);
                }, function () {
                });
            }
        });
        $transitions.onBefore({ to: ['index_HU', 'index_HU.*'] }, function (trans) {
            if (!navigator.language.includes('hu') && !navigator.language.includes('hu-HU') && $cookies.get('huLangPreffered') != 'true') {
                $state.go('index.home');
                return trans.abort();
            }
            if ($rootScope.browserIsOnline === false) {
                location.reload();
                return trans.abort();
            }
        });
        $transitions.onSuccess({ to: ['index_HU.home', 'index.home'] }, function (trans) {
            if ($stateParams.obj == "main" || $location.hash() == "main") {
                const newHash = 'main';
                if ($location.hash() !== newHash) {
                    $location.hash('main');
                } else {
                    $anchorScroll();
                }
            } else if ($stateParams.obj == "discount" || $location.hash() == "discount") {
                const newHash = 'discount';
                if ($location.hash() !== newHash) {
                    $location.hash('discount');
                } else {
                    $anchorScroll();
                }
            } else if ($stateParams.obj == "yaltyApp" || $location.hash() == "yaltyApp") {
                const newHash = 'yaltyApp';
                if ($location.hash() !== newHash) {
                    $location.hash('yaltyApp');
                } else {
                    $anchorScroll();
                }
            }
        });
        $transitions.onStart({ to: 'home.preRegistrationLanding' }, function (trans) {
            var authService = trans.injector().get('AuthService');
            return authService.getPartnerPreregistrationData().then(function (result) {
                if (result.data.errorCode == 0) {
                    $rootScope.sub = result.data.preRegistrationData;
                    $rootScope.authorizationLevel = result.data.authorizationLevel;
                    $cookies.put('isPartnerRegistered', false);
                    logPartnerActivityBeforeRegistration()
                } else if (result.data.errorCode == 1) {
                    trans.abort();
                    $mdDialog.show({
                        template:
                            '<md-dialog>' +
                            '  <md-dialog-content class="md-dialog-content">' +
                            '<h2 class="md-title">Érvénytelen vagy már felhasznált regisztrációs link.</h2> ' +
                            'Ha még nem regisztrált vagy kérdése van, kérjük töltse ki információ kérő <a ng-click="navigate()">adatlapunkat</a>.' +
                            '  </md-dialog-content>' +
                            '  <md-dialog-actions>' +
                            '    <md-button ng-click="closeDialog()" class="md-primary">' +
                            '      Rendben' +
                            '    </md-button>' +
                            '  </md-dialog-actions>' +
                            '</md-dialog>',
                        controller: DialogCtrl
                    });
                }
            });
        });
        $transitions.onStart({ to: 'home.newPreRegistrationLanding' }, function (trans) {
            var authService = trans.injector().get('AuthService');
            return authService.getPartnerPreregistrationData().then(function (result) {
                if (result.data.errorCode == 0) {
                    $rootScope.sub = result.data.preRegistrationData;
                    $cookies.put('isYaltyStartEnabled', result.data.preRegistrationData[0].isYaltyStartPaidPackageEnabled, { 'expires': result.data.preRegistrationData[0].activationStringExpTimestamp });
                    $rootScope.authorizationLevel = result.data.authorizationLevel;
                    $rootScope.activationStringExpTimestamp = result.data.preRegistrationData[0].activationStringExpTimestamp;
                    $cookies.put('isPartnerRegistered', false, { 'expires': result.data.preRegistrationData[0].activationStringExpTimestamp });
                    logPartnerActivityBeforeRegistration()
                } else if (result.data.errorCode == 1) {
                    trans.abort();
                    $mdDialog.show({
                        template:
                            '<md-dialog>' +
                            '  <md-dialog-content class="md-dialog-content">' +
                            '<h2 class="md-title">Érvénytelen vagy már felhasznált regisztrációs link.</h2> ' +
                            'Ha még nem regisztrált vagy kérdése van, kérjük töltse ki információ kérő <a ng-click="navigate()">adatlapunkat</a>.' +
                            '  </md-dialog-content>' +
                            '  <md-dialog-actions>' +
                            '    <md-button ng-click="closeDialog()" class="md-primary">' +
                            '      Rendben' +
                            '    </md-button>' +
                            '  </md-dialog-actions>' +
                            '</md-dialog>',
                        controller: DialogCtrl
                    });
                }
            });
        });
        $transitions.onStart({ to: 'home.preRegistration' }, function (trans) {
            var authService = trans.injector().get('AuthService');
            return authService.getPartnerPreregistrationData().then(function (result) {
                if (result.data.errorCode == 0) {
                    $rootScope.sub = result.data.preRegistrationData;
                    $rootScope.authorizationLevel = result.data.authorizationLevel;
                    $cookies.put('isPartnerRegistered', false, { 'expires': result.data.preRegistrationData[0].activationStringExpTimestamp });
                    logPartnerActivityAtRegistration()
                } else if (result.data.errorCode == 1) {
                    trans.abort();
                    $mdDialog.show({
                        template:
                            '<md-dialog>' +
                            '  <md-dialog-content class="md-dialog-content">' +
                            '<h2 class="md-title">Érvénytelen vagy már felhasznált regisztrációs link.</h2> ' +
                            'Ha még nem regisztrált vagy kérdése van, kérjük töltse ki információ kérő <a ng-click="navigate()">adatlapunkat</a>.' +
                            '  </md-dialog-content>' +
                            '  <md-dialog-actions>' +
                            '    <md-button ng-click="closeDialog()" class="md-primary">' +
                            '      Rendben' +
                            '    </md-button>' +
                            '  </md-dialog-actions>' +
                            '</md-dialog>',
                        controller: DialogCtrl
                    });
                }
            });
        });
        $transitions.onStart({ to: 'home.settingsActivation' }, function (trans) {
            var userAccountService = trans.injector().get('UserAccountService');
            return userAccountService.getUserData().then(function (result) {
                if (result.errorCode == 0) {
                    $rootScope.userData = result;
                    $cookies.put('currentUserType', result.currentUserType);
                    $cookies.put('authorizationLevel', result.partnerUserData[0].authorizationLevel);
                } else if (result.errorCode == 1) {
                    trans.abort();
                    $state.go('partner_HU.login');
                }
            });
        });
        $transitions.onStart({ to: 'finallyPartnerRemove' }, function (trans) {
            var authService = trans.injector().get('AuthService');
            return authService.checkPartnerDeleteLinkExpiration().then(function (result) {
                $rootScope.errCode = result.data.errorCode;
                $rootScope.expired = result.data.expired;
            }, function (result) {
                $rootScope.errCode = result.data.errorCode;
                $rootScope.expired = result.data.expired;
            });
        });
        $transitions.onStart({ to: 'activatePartnerUser' }, function (trans) {
            var authService = trans.injector().get('AuthService');
            return authService.checkActivationStringExpiration()
                .then(function (result) {
                    $rootScope.isMaster = result.data.isMasterUser
                    $rootScope.errCode = result.data.errorCode;
                    $rootScope.expired = result.data.expired;
                }, function (result) {
                    $rootScope.errCode = result.data.errorCode;
                    $rootScope.expired = result.data.expired;
                });
        });
        $transitions.onStart({ to: 'activateUser' }, function (trans) {
            var authService = trans.injector().get('AuthService');
            return authService.activateUser().then(function (result) {
                $rootScope.errCode = result.data.errorCode;
                $rootScope.emailAddress = result.data.emailAddress;
            }, function (result) {
                $rootScope.errCode = result.data.errorCode;
                $rootScope.emailAddress = result.data.emailAddress;
            });
        });
        $transitions.onStart({ to: 'resetUserPassword' }, function (trans) {
            var authService = trans.injector().get('AuthService');
            return authService.checkPasswordResetStringExpiration('user').then(function (result) {
                $rootScope.expired = null;
                $rootScope.expired = result.data.expired;
            }, function (result) {
                $rootScope.expired = null;
                $rootScope.expired = result.data.expired;
            });
        });
        $transitions.onStart({ to: 'resetPartnerUserPassword' }, function (trans) {
            var authService = trans.injector().get('AuthService');
            return authService.checkPasswordResetStringExpiration('partner').then(function (result) {
                $rootScope.expired = null;
                $rootScope.expired = result.data.expired;
            }, function (result) {
                $rootScope.expired = null;
                $rootScope.expired = result.data.expired;
            });
        });
        $transitions.onStart({ to: ['adminLogin', 'adminPages', 'adminPages.*'] }, function (trans) {
            $rootScope.$on('timer-tick', function (event, data) {
                var current = Date.parse(new Date());
                if ($rootScope.timerRunning === true && current >= $rootScope.deadlineInMilli && $rootScope.isConfirmDialogShow === false && $rootScope.visibilityState == "visible") {
                    $rootScope.isConfirmDialogShow = true;
                    $mdDialog.show(confirm).then(function () {
                        var currentState = $state.current.name;
                        $rootScope.isConfirmDialogShow = false;
                        var payload = {};
                        payload.state = currentState;
                        payload.fromState = currentState;
                        YaltyAuthService.isYaltyAdminUserAuthorized(payload).then(function (result) {
                            if (result.endDate && result.alertDate && result.errorCode == 0) {
                                setCookiesFromAdminResult(result);
                                $rootScope.endDate = result.endDate;
                                $rootScope.deadlineInMilli = result.alertDate;
                                $rootScope.isTimerSet = true;
                                $rootScope.$broadcast('timer-clear');
                                $rootScope.$broadcast('timer-start');
                                $rootScope.timerRunning = true;
                            } else {
                                $rootScope.isTimerSet = false;
                                var alert = $mdDialog.alert()
                                    .title('Sikertelen azonosítás')
                                    .textContent('Felhasználó azonosítása sikertelen, ezért kiléptetjük az oldalról.')
                                    .ariaLabel('Session expired.')
                                    .ok('Rendben')
                                $mdDialog.show(alert).then(function () {
                                    $state.go('adminLogin');
                                });
                            }
                        }, function (errorCode) {
                            var alert = $mdDialog.alert()
                                .title('Sikertelen azonosítás')
                                .textContent('Felhasználó azonosítása sikertelen, ezért ki kell léptetnünk az oldalról.')
                                .ariaLabel('Session expired.')
                                .ok('Rendben')
                            $mdDialog.show(alert).then(function () {
                                $state.go('adminLogin');
                            });
                        }).catch(function () {
                            var alert = $mdDialog.alert()
                                .title('Sikertelen azonosítás')
                                .textContent('A felhasználó azonosítása sikertelen, ezért kiléptetjük az oldalról.')
                                .ariaLabel('Session expired.')
                                .ok('Rendben')
                            $mdDialog.show(alert).then(function () {
                                $state.go('adminLogin');
                            });
                        });
                    }, function () {
                        $rootScope.isConfirmDialogShow = false;
                        $rootScope.$broadcast('timer-clear');
                        $state.go('adminLogin', { 'errorText': 'Sikeres kijelentkezés.' });
                    });
                }
            });
            $rootScope.$on('timer-stopped', function (event, data) {
                if ($rootScope.isDataSheetModified == true) {
                    $rootScope.isDataSheetModified = false;
                }
                if ($rootScope.isConfirmDialogShow == true) {
                    $mdDialog.cancel(confirm);
                } else {
                    $rootScope.$broadcast('timer-clear');
                    $state.go('adminLogin', { 'errorText': 'Lejárt az időkorlát.' });
                }

            });
            var toState = trans.$to();
            var fromState = trans.from();
            if (toState.name == 'adminLogin') {
                $state.go('adminLogin');
                $cookies.remove('userName');
                $cookies.remove('userEmail');
                $cookies.remove('userType');
                $rootScope.userType = null;
            }
            var states = {};
            states.state = toState.name;
            states.fromState = fromState.name;
            var authService = trans.injector().get('YaltyAuthService');
            return authService.isYaltyAdminUserAuthorized(states).then(function (result) {
                if (result.endDate && result.alertDate) {
                    setCookiesFromAdminResult(result);
                    $rootScope.endDate = result.endDate;
                    $rootScope.deadlineInMilli = result.alertDate;
                    $rootScope.isTimerSet = true;
                    $rootScope.$broadcast('timer-clear');
                    $rootScope.$broadcast('timer-start');
                    $rootScope.timerRunning = true;
                } else {
                    $rootScope.isTimerSet = false;
                }
                if (result.errorCode == 1) {
                    return trans.abort();
                } else if (result.errorCode == 2) {
                    const alert = $mdDialog.alert()
                        .title('Sikertelen azonosítás')
                        .textContent('Felhasználó azonosítása sikertelen szerverhiba miatt, ezért kiléptetjük az oldalról.')
                        .ariaLabel('Session expired.')
                        .ok('Rendben')
                    $mdDialog.show(alert).then(function () {
                        $rootScope.isDataSheetModified = false;
                        $state.go('adminLogin');
                    });
                    return trans.abort();
                } else if (result.errorCode == 3) {
                    const alert = $mdDialog.alert()
                        .title('Sikertelen azonosítás')
                        .textContent('Felhasználó azonosítása sikertelen, ezért kiléptetjük az oldalról.')
                        .ariaLabel('Session expired.')
                        .ok('Rendben')
                    $mdDialog.show(alert).then(function () {
                        $state.go('adminLogin');
                    });
                }
            });
        });
        $transitions.onStart({ to: ['partner.login', 'partner_HU.login', 'partner.contact', 'partner_HU.contact', 'home', 'home.*', 'activateMasterUser'] }, function (trans) {
            $rootScope.$on('timer-tick', function (event, data) {
                if ($rootScope.endDate != $cookies.get('expdt')) {
                    if (isNaN(parseInt($cookies.get('expdt')))) {
                        loggedOutFromPartnerPage();
                    } else {
                        $rootScope.endDate = parseInt($cookies.get('expdt'));
                        $rootScope.deadlineInMilli = parseInt($cookies.get('alrtdt'));
                        if ($rootScope.isConfirmDialogShow == true) {
                            $mdDialog.hide(confirm);
                        }
                    }
                }
                var current = Date.parse(new Date());
                if ($rootScope.timerRunning === true && current >= $rootScope.deadlineInMilli && $rootScope.isConfirmDialogShow === false && $rootScope.visibilityState == "visible") {
                    $rootScope.isConfirmDialogShow = true;
                    $mdDialog.show(confirm).then(function () {
                        $rootScope.$broadcast('timer-clear');
                        if (document.getElementById('transitionOverlay')) {
                            document.getElementById('transitionOverlay').style.display = "block";
                        }
                        var currentState = $state.current.name;
                        var payload = {};
                        payload.state = currentState;
                        payload.fromState = currentState;
                        AuthService.isUserAuthorized(payload).then(function (result) {
                            if (document.getElementById('transitionOverlay')) {
                                document.getElementById('transitionOverlay').style.display = "none";
                            }
                            $rootScope.isConfirmDialogShow = false;
                            if (result.endDate && result.alertDate && result.errorCode == 0) {
                                /*$rootScope.endDate = result.endDate;
                                $rootScope.deadlineInMilli = result.alertDate;*/
                                $rootScope.isTimerSet = true;
                                $rootScope.timerRunning = true;
                                setCookiesFromResult(result);
                                $rootScope.$broadcast('timer-start');
                            } else {
                                $rootScope.isTimerSet = false;
                                var alert = $mdDialog.alert()
                                    .title('Sikertelen azonosítás')
                                    .textContent('Felhasználó azonosítása sikertelen, ezért kiléptetjük az oldalról.')
                                    .ariaLabel('Session expired.')
                                    .ok('Rendben')
                                $mdDialog.show(alert).then(function () {
                                    loggedOutFromPartnerPage();
                                });
                            }
                        }, function (errorCode) {
                            var alert = $mdDialog.alert()
                                .title('Sikertelen azonosítás')
                                .textContent('Felhasználó azonosítása sikertelen, ezért ki kell léptetnünk az oldalról.')
                                .ariaLabel('Session expired.')
                                .ok('Rendben')
                            $mdDialog.show(alert).then(function () {
                                loggedOutFromPartnerPage();
                            });
                        }).catch(function () {
                            var alert = $mdDialog.alert()
                                .title('Sikertelen azonosítás')
                                .textContent('A felhasználó azonosítása sikertelen, ezért kiléptetjük az oldalról.')
                                .ariaLabel('Session expired.')
                                .ok('Rendben')
                            $mdDialog.show(alert).then(function () {
                                loggedOutFromPartnerPage();
                            });
                        });
                    }, function () {
                        $rootScope.isConfirmDialogShow = false;
                        $rootScope.$broadcast('timer-clear');
                        if ($rootScope.timerRunning == true) {
                            loggedOutFromPartnerPage();
                        } else {
                            loggedOutFromPartnerPage("timeout");
                        }
                    });
                }
            });
            $rootScope.$on('timer-stopped', function (event, data) {
                $rootScope.timerRunning = false;
                if ($rootScope.isDataSheetModified == true) {
                    $rootScope.isDataSheetModified = false;
                }
                if ($rootScope.isConfirmDialogShow == true) {
                    $mdDialog.cancel(confirm);
                } else {
                    $rootScope.$broadcast('timer-clear');
                    loggedOutFromPartnerPage("timeout");
                }

            });
            $rootScope.currentCoupon = null;
            var toState = trans.$to();
            var fromState = trans.from();
            var states = {};
            states.state = toState.name;
            states.fromState = fromState.name;
            var authService = trans.injector().get('AuthService');
            return authService.isUserAuthorized(states).then(function (result) {
                if ((toState.name == "partner_HU.login" || toState.name == "partner_HU.contact") && result.errorCode == 0 && result.authorized == true) {
                    if ($location.search().emailAddress && $cookies.get('userEmail') == $location.search().emailAddress) {
                        if ($location.search().redirectToPayment == "true") {
                            location.href = "/partner/home/partner-subscription?prefillPaymentDetails=true";
                        } else if ($location.search().redirectToMarketingPackage) {
                            $state.go('home.huseg3', { loyaltyCardId: $location.search().lcyid });
                        }
                    } else if ($cookies.get('userEmail') != null && $location.search().emailAddress && $cookies.get('userEmail') != $location.search().emailAddress) {
                        AuthService.logout('noredirect');
                    } else $state.go('home');
                } else if ((toState.name == "partner.login" || toState.name == "partner.contact") && result.errorCode == 0 && result.authorized == true) {
                    $state.go('home');
                } else if (toState.name == "partner_HU.login" && result.authorized == false) {
                    AuthService.removeCookies();
                } else if (toState.name == "partner.login" && result.authorized == false) {
                    //loggedOutFromPartnerPage();
                    AuthService.removeCookies();
                }
                if (result.endDate && result.alertDate) {
                    $rootScope.endDate = result.endDate;
                    $rootScope.deadlineInMilli = result.alertDate;
                    $rootScope.isTimerSet = true;
                    $rootScope.timerRunning = true;
                    setCookiesFromResult(result);
                } else {
                    $rootScope.isTimerSet = false;
                }
                if (result.errorCode == 1) {
                    return trans.abort();
                } else if (result.errorCode == 2) {
                    /*const alert = $mdDialog.alert()
                        .title('Lejárt a belépési időkorlát')
                        .textContent('Az oldalunk 60 perces időkorláttal van ellátva, 60 perc leteltével kiléptetjük az oldalról.')
                        .ariaLabel('Session expired.')
                        .ok('Rendben')
                    $mdDialog.show(alert).then(function () {*/
                    $rootScope.isDataSheetModified = false;
                    loggedOutFromPartnerPage();
                    //});
                    return trans.abort();
                } else if (result.errorCode == 3) {
                    if (fromState.name == "home.cashing") {
                        /*var confirm = $mdDialog.confirm()
                            .title('A belső partneri oldalak időkerete lejárt.')
                            .textContent('Ha a belső oldalakra navigálna, akkor újra be kell jelentkeznie. Ha a beváltási oldalon maradna nyomja meg a MÉGSEM gombot.')
                            .ok('BEJELENTKEZÉS')
                            .cancel('MÉGSEM');
                        $mdDialog.show(confirm).then(function () {*/
                        $rootScope.isDataSheetModified = false;
                        loggedOutFromPartnerPage();
                        //}, function () {});
                        return trans.abort();
                    } else {
                        /*const alert = $mdDialog.alert()
                            .title('Lejárt a belépési időkorlát')
                            .textContent('Az oldal 60 perces időkorláttal van ellátva, 58 perc leteltével kiléptetjük az oldalról.')
                            .ariaLabel('Session expired.')
                            .ok('Rendben')
                        $mdDialog.show(alert).then(function () {*/
                        $rootScope.isDataSheetModified = false;
                        loggedOutFromPartnerPage();
                        //});
                        return trans.abort();
                    }
                } else if (result.errorCode == 4) {
                    loggedOutFromPartnerPage();
                }
            }, function () {
                if ($rootScope.browserIsOnline === false) {
                    location.reload();
                    return trans.abort();
                } else if (toState != fromState) {
                    $rootScope.isDataSheetModified = false;
                    loggedOutFromPartnerPage();
                }
            }).catch(function (err) {
                return trans.abort();
            });
        });
        $transitions.onStart({ to: 'cashRegisterCashing' }, function (trans) {
            var toState = trans.$to();
            var fromState = trans.from();
            var states = {};
            states.state = toState.name;
            states.fromState = fromState.name;
            var authService = trans.injector().get('AuthService');
            return authService.isUserAuthorized(states).then(function (result) {
                if (result.endDate && result.alertDate) {
                    $rootScope.endDate = result.endDate;
                    $rootScope.deadlineInMilli = result.alertDate;
                    $rootScope.isTimerSet = true;
                    $rootScope.timerRunning = true;
                    setCookiesFromResult(result);
                } else {
                    $rootScope.isTimerSet = false;
                }
                if (result.errorCode == 1) {
                    return trans.abort();
                } else if (result.errorCode == 2) {
                    /*const alert = $mdDialog.alert()
                        .title('Lejárt a belépési időkorlát')
                        .textContent('Az oldalunk 60 perces időkorláttal van ellátva, 60 perc leteltével kiléptetjük az oldalról.')
                        .ariaLabel('Session expired.')
                        .ok('Rendben')
                    $mdDialog.show(alert).then(function () {*/
                    $rootScope.isDataSheetModified = false;
                    loggedOutFromPartnerPage("cashRegisterLogout");
                    //});
                    return trans.abort();
                } else if (result.errorCode == 3) {
                    if (fromState.name == "home.cashing") {
                        /*var confirm = $mdDialog.confirm()
                            .title('A belső partneri oldalak időkerete lejárt.')
                            .textContent('Ha a belső oldalakra navigálna, akkor újra be kell jelentkeznie. Ha a beváltási oldalon maradna nyomja meg a MÉGSEM gombot.')
                            .ok('BEJELENTKEZÉS')
                            .cancel('MÉGSEM');
                        $mdDialog.show(confirm).then(function () {*/
                        $rootScope.isDataSheetModified = false;
                        loggedOutFromPartnerPage("cashRegisterLogout");
                        /*}, function () {
                        });*/
                        return trans.abort();
                    } else {
                        /*const alert = $mdDialog.alert()
                            .title('Lejárt a belépési időkorlát')
                            .textContent('Az oldal 60 perces időkorláttal van ellátva, 58 perc leteltével kiléptetjük az oldalról.')
                            .ariaLabel('Session expired.')
                            .ok('Rendben')
                        $mdDialog.show(alert).then(function () {*/
                        $rootScope.isDataSheetModified = false;
                        loggedOutFromPartnerPage("cashRegisterLogout");
                        //});
                        return trans.abort();
                    }
                } else if (result.errorCode == 4) {
                    loggedOutFromPartnerPage("cashRegisterLogout");
                }
            }, function () {
                if ($rootScope.browserIsOnline === false) {
                    location.reload();
                    return trans.abort();
                } else if (toState != fromState) {
                    $rootScope.isDataSheetModified = false;
                    loggedOutFromPartnerPage("cashRegisterLogout");
                }
            }).catch(function (err) {
                return trans.abort();
            });
        });
        $transitions.onStart({}, function (trans) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            $(".main").animate({ scrollTop: 0 }, "fast");
            if (document.getElementById('transitionOverlay')) {
                document.getElementById('transitionOverlay').style.display = "block";
                document.getElementById('innerPartnerPageContainer').style.overflow = "hidden";
            }
        });
        $transitions.onSuccess({}, function (trans) {
            if (document.getElementById('transitionOverlay')) {
                document.getElementById('transitionOverlay').style.display = "none";
                document.getElementById('innerPartnerPageContainer').style.overflow = "unset";
            }
            GoogleAnalyticsService.sendDataToGA(getGAFromLocationURL($location.url(), "page"), getGAFromLocationURL($location.url(), "title"));
        });

        function DialogCtrl($scope, $mdDialog) {
            $scope.closeDialog = function () {
                $mdDialog.hide();
                document.location = $location.protocol() + "://" + location.host + "/partnerHU/loginHU";
            }
            $scope.navigate = function () {
                $mdDialog.hide();
                document.location = $location.protocol() + "://" + location.host + "/partnerHU/contactHU";
            }
        }

        var setCookiesFromResult = function (result) {
            AuthService.updateSessionData(result)
            $rootScope.partnerSubscriptionType = $cookies.get('sbcrtyp') ? $cookies.get('sbcrtyp').split("&")[0] : "";
        }

        var setCookiesFromAdminResult = function (result) {
            var userEmail = $cookies.get('adminUserEmail');
            var userName = $cookies.get('adminUserName');
            var userType = $cookies.get('adminUserType');
            var userId = $cookies.get('adminUserId');
            var userPhoneNumber = $cookies.get('adminPhoneNumber');
            var expireDate = new Date(result.endDate);
            $cookies.put('expdt', result.endDate, { 'expires': expireDate });
            $cookies.put('alrtdt', result.alertDate, { 'expires': expireDate });
            $cookies.put('adminUserName', userName, { 'expires': expireDate });
            $cookies.put('adminUserEmail', userEmail, { 'expires': expireDate });
            $cookies.put('adminUserType', userType, { 'expires': expireDate });
            $cookies.put('adminUserId', userId, { 'expires': expireDate });
            $cookies.put('adminPhoneNumber', userPhoneNumber, { 'expires': expireDate });
        }

        var loggedOutFromPartnerPage = function (reason = "logout") {
            AuthService.logout(reason);
        }

        var logPartnerActivityAtRegistration = function () {
            var logData = {}
            logData.userIPAddress = 'Unknown'
            logData.pageName = 'Regisztrációs oldal'
            logData.pageStandardName = 'c3_registration'
            logData.deviceType = 'Unknown'
            logData.deviceName = 'Unknown'
            logData.osType = "Unknown";
            logData.osVersion = 'Unknown'
            logData.browserUserAgent = 'Unknown'
            logData.browserVersion = 'Unknown';
            logData.browserName = 'Unknown';
            try {
                var md = new MobileDetect(window.navigator.userAgent);
                if (md.phone() != null) {
                    logData.deviceType = 'Mobile'
                    logData.deviceName = md.mobile();
                } else if (md.tablet() != null) {
                    logData.deviceType = 'Tablet'
                    logData.deviceName = md.tablet();
                } else {
                    logData.deviceType = 'Desktop'
                    logData.deviceName = 'Unknown'
                }
                if (logData.deviceName == "UnknownMobile" || logData.deviceName == "UnknownPhone" || logData.deviceName == "UnknownTablet") {
                    logData.deviceName = "Other";
                }
            } catch (err) {
                if (logData.etc == null) {
                    logData.etc = err;
                } else {
                    logData.etc += (" || " + err);
                }
            }
            try {
                var userAgent = window.navigator.userAgent,
                    platform = window.navigator.platform,
                    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
                    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
                    iosPlatforms = ['iPhone', 'iPad', 'iPod'];
                logData.browserUserAgent = userAgent.trunc(499);
                if (macosPlatforms.indexOf(platform) !== -1) {
                    logData.osType = 'Mac OS';
                } else if (iosPlatforms.indexOf(platform) !== -1) {
                    logData.osType = 'iOS';
                    if (md.version('iOS') != null) {
                        logData.osVersion = md.version('iOS');
                    }
                } else if (windowsPlatforms.indexOf(platform) !== -1) {
                    logData.osType = 'Windows';
                } else if (/Android/.test(userAgent)) {
                    logData.osType = 'Android';
                    if (md.version('Android') != null) {
                        logData.osVersion = md.version('Android');
                    }
                } else if (!os && /Linux/.test(platform)) {
                    logData.osType = 'Linux';
                }
                if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "10";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "8";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "7";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "Vista";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "XP";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "2000";
                }
            } catch (err) {
                if (logData.etc == null) {
                    logData.etc = err;
                } else {
                    logData.etc += (" || " + err);
                }
            }
            try {
                // Opera 8.0+
                var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

                // Firefox 1.0+
                var isFirefox = typeof InstallTrigger !== 'undefined';

                // Safari 3.0+ "[object HTMLElementConstructor]" 
                var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

                // Internet Explorer 6-11
                var isIE = /*@cc_on!@*/false || !!document.documentMode;

                // Edge 20+
                var isEdge = !isIE && !!window.StyleMedia;

                // Chrome 1 - 71
                var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
                if (isOpera) {
                    logData.browserName = 'Opera';
                } else if (isFirefox) {
                    logData.browserName = 'Firefox';
                } else if (isIE) {
                    logData.browserName = 'IE';
                } else if (isEdge) {
                    logData.browserName = 'Edge';
                } else if (isSafari) {
                    logData.browserName = 'Safari';
                } else if (isChrome) {
                    logData.browserName = 'Chrome';
                } else {
                    logData.browserName = 'Unknown';
                }
            } catch (err) {
                if (logData.etc == null) {
                    logData.etc = err;
                } else {
                    logData.etc += (" || " + err);
                }
            }
            try {
                logData.devicePhysicalHeight = screen.height * window.devicePixelRatio;
                logData.devicePhysicalWidth = screen.width * window.devicePixelRatio;
                logData.deviceViewportHeight = document.documentElement.clientHeight;
                logData.deviceViewportWidth = document.documentElement.clientWidth;
            } catch (err) {
                if (logData.etc == null) {
                    logData.etc = err;
                } else {
                    logData.etc += (" || " + err);
                }
            }
            var url = $location.absUrl();
            if (!url.includes("?preview") && $cookies.get('isPartnerRegistered') == 'false') {
                $http.post(API_PREFIX.url + '/partner/companyRegPageSalesPotentialActivityLogs', logData)
            }
        }

        String.prototype.trunc = String.prototype.trunc ||
            function (n) {
                return (this.length > n) ? this.substr(0, n - 1) + '&hellip;' : this;
            };

        var logPartnerActivityBeforeRegistration = function () {
            var logData = {}
            logData.userIPAddress = 'Unknown'
            logData.pageName = 'Üdvözlő képernyő'
            logData.pageStandardName = 'c1_landing'
            logData.deviceType = 'Unknown'
            logData.deviceName = 'Unknown'
            logData.osType = "Unknown";
            logData.osVersion = 'Unknown'
            logData.browserUserAgent = 'Unknown'
            logData.browserVersion = 'Unknown';
            logData.browserName = 'Unknown';
            try {
                var md = new MobileDetect(window.navigator.userAgent);
                if (md.phone() != null) {
                    logData.deviceType = 'Mobile'
                    logData.deviceName = md.mobile();
                } else if (md.tablet() != null) {
                    logData.deviceType = 'Tablet'
                    logData.deviceName = md.tablet();
                } else {
                    logData.deviceType = 'Desktop'
                    logData.deviceName = 'Unknown'
                }
                if (logData.deviceName == "UnknownMobile" || logData.deviceName == "UnknownPhone" || logData.deviceName == "UnknownTablet") {
                    logData.deviceName = "Other";
                }
            } catch (err) {
                if (logData.etc == null) {
                    logData.etc = err;
                } else {
                    logData.etc += (" || " + err);
                }
            }
            try {
                var userAgent = window.navigator.userAgent,
                    platform = window.navigator.platform,
                    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
                    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
                    iosPlatforms = ['iPhone', 'iPad', 'iPod'];
                logData.browserUserAgent = userAgent.trunc(499);
                if (macosPlatforms.indexOf(platform) !== -1) {
                    logData.osType = 'Mac OS';
                } else if (iosPlatforms.indexOf(platform) !== -1) {
                    logData.osType = 'iOS';
                    if (md.version('iOS') != null) {
                        logData.osVersion = md.version('iOS');
                    }
                } else if (windowsPlatforms.indexOf(platform) !== -1) {
                    logData.osType = 'Windows';
                } else if (/Android/.test(userAgent)) {
                    logData.osType = 'Android';
                    if (md.version('Android') != null) {
                        logData.osVersion = md.version('Android');
                    }
                } else if (!os && /Linux/.test(platform)) {
                    logData.osType = 'Linux';
                }
                if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "10";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "8";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "7";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "Vista";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "XP";
                }
                if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) {
                    logData.osType = "Windows";
                    logData.osVersion = "2000";
                }
            } catch (err) {
                if (logData.etc == null) {
                    logData.etc = err;
                } else {
                    logData.etc += (" || " + err);
                }
            }
            try {
                // Opera 8.0+
                var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

                // Firefox 1.0+
                var isFirefox = typeof InstallTrigger !== 'undefined';

                // Safari 3.0+ "[object HTMLElementConstructor]" 
                var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

                // Internet Explorer 6-11
                var isIE = /*@cc_on!@*/false || !!document.documentMode;

                // Edge 20+
                var isEdge = !isIE && !!window.StyleMedia;

                // Chrome 1 - 71
                var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
                if (isOpera) {
                    logData.browserName = 'Opera';
                } else if (isFirefox) {
                    logData.browserName = 'Firefox';
                } else if (isIE) {
                    logData.browserName = 'IE';
                } else if (isEdge) {
                    logData.browserName = 'Edge';
                } else if (isSafari) {
                    logData.browserName = 'Safari';
                } else if (isChrome) {
                    logData.browserName = 'Chrome';
                } else {
                    logData.browserName = 'Unknown';
                }
            } catch (err) {
                if (logData.etc == null) {
                    logData.etc = err;
                } else {
                    logData.etc += (" || " + err);
                }
            }
            try {
                logData.devicePhysicalHeight = screen.height * window.devicePixelRatio;
                logData.devicePhysicalWidth = screen.width * window.devicePixelRatio;
                logData.deviceViewportHeight = document.documentElement.clientHeight;
                logData.deviceViewportWidth = document.documentElement.clientWidth;
            } catch (err) {
                if (logData.etc == null) {
                    logData.etc = err;
                } else {
                    logData.etc += (" || " + err);
                }
            }
            var url = $location.absUrl();
            if (!url.includes("?preview") && $cookies.get('isPartnerRegistered') == 'false') {
                $http.post(API_PREFIX.url + '/partner/companyRegPageSalesPotentialActivityLogs', logData)
            }
        }

        var getGAFromLocationURL = function (location, pageOrTitle) {
            var parted = location.split("=");
            if (location == "/indexHU/home#main" || location == "/indexHU/home") {
                if (pageOrTitle == "page") {
                    return "/HU/felhasználói/kezdőlap";
                } else if (pageOrTitle == "title") {
                    return "HU Kezdőlap";
                }
            } else if (location == "/discountHU") {
                if (pageOrTitle == "page") {
                    return "/HU/felhasználói/kedvezmények";
                } else if (pageOrTitle == "title") {
                    return "HU Kedvezmények";
                }
            } else if (location == "/indexHU/home#yaltyApp") {
                if (pageOrTitle == "page") {
                    return "/HU/felhasználói/yalty_app";
                } else if (pageOrTitle == "title") {
                    return "HU Yalty App";
                }
            } else if (location == "/partnerHU/loginHU") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/bejelentkezés";
                } else if (pageOrTitle == "title") {
                    return "HU Partner - Bejelentkezés";
                }
            } else if (location == "/partnerHU/contactHU") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/kapcsolati_lap";
                } else if (pageOrTitle == "title") {
                    return "HU Partner - Kapcsolati lap (CONTACT FORM)";
                }
            } else if (location == "/partnerHU/resetPartnerUserPasswordHU") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/elfelejtett_jelszó";
                } else if (pageOrTitle == "title") {
                    return "HU Partner - Elfelejtett jelszó";
                }
            } else if (location == "/index/#main" || location == "/index/") {
                if (pageOrTitle == "page") {
                    return "/EN/felhasználói/kezdőlap";
                } else if (pageOrTitle == "title") {
                    return "EN Kezdőlap";
                }
            } else if (location == "/index/#yaltyApp") {
                if (pageOrTitle == "page") {
                    return "/EN/felhasználói/yalty_app";
                } else if (pageOrTitle == "title") {
                    return "EN Yalty App";
                }
            } else if (location == "/partner/login") {
                if (pageOrTitle == "page") {
                    return "/EN/partneri/bejelentkezés";
                } else if (pageOrTitle == "title") {
                    return "EN Partner - Bejelentkezés";
                }
            } else if (location == "/partner/contact") {
                if (pageOrTitle == "page") {
                    return "/EN/partneri/kapcsolati_lap";
                } else if (pageOrTitle == "title") {
                    return "EN Partner - Kapcsolati lap (CONTACT FORM)";
                }
            } else if (location == "/partner/resetPartnerUserPassword") {
                if (pageOrTitle == "page") {
                    return "/EN/partneri/elfelejtett_jelszó";
                } else if (pageOrTitle == "title") {
                    return "EN Partner - Elfelejtett jelszó";
                }
            } else if (location == "/partner/home") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/üdvözlő_oldal"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Üdvözlő oldal"
                }
            } else if (location == "/partner/home/cashing") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/beváltások_kezelése"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Beváltások kezelése oldal"
                }
            } else if (location == "/partner/home/kupon") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/kuponok_információs_oldal"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Kuponok információs oldal"
                }
            } else if (location == "/partner/home/kupon1") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/kuponok_információs_oldal"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Kuponok információs oldal"
                }
            } else if (/^(\/partner\/home\/kupon2\/\d{1,})$/.test(location)) {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/kuponok_kuponjaink"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Kuponjaink oldal"
                }
            } else if (location == "/partner/home/huseg") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/hűségkártyák_információs_oldal"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Hűségkártyák oldal információs oldal"
                }
            } else if (location == "/partner/home/huseg1") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/hűségkártyák_információs_oldal"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Hűségkártyák oldal információs oldal"
                }
            } else if (/^(\/partner\/home\/huseg2\/\d{1,})$/.test(location)) {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/hűségkártyáink"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Hűségkártyáink oldal"
                }
            } else if (location == "/partner/home/statistic") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/statisztikák"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Statisztikák oldal"
                }
            } else if (location == "/partner/home/analitics") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/analitika"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Analitika oldal"
                }
            } else if (location == "/partner/home/campaign") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/kampány"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Kampány oldal"
                }
            } else if (location == "/partner/home/bills") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/számlák"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Számlák oldal"
                }
            } else if (location == "/partner/home/settings") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/partneri_adatok"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Partneri adatok oldal"
                }
            } else if (location == "/partner/home/users") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/felhasználói_fiókok"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Felhasználói fiókok oldal"
                }
            } else if (location == "/partner/home/stores") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/üzletek"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Üzletek oldal"
                }
            } else if (location == "/partner/home/aggregate-partner-company-stores") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/üzletek_csoportos_kezelése"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Üzletek csoportos kezelése oldal"
                }
            } else if (location == "/partner/home/loyaltycardyalty-redeems-history") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/hűségkártya_beváltások_története"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Hűségkártya beváltások története oldal"
                }
            } else if (location == "/partner/home/partner-activity-history") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/partneri_módosítás_történet"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Partneri módosítás történet oldal"
                }
            } else if (location == "/partner/home/settingsActivation") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/felhasználói_fiók_aktiváció"
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Felhasználói fiók aktiváció oldal"
                }
            } else if (parted[0] == "/service/resetUserPassword?reset") {
                if (pageOrTitle == "page") {
                    return "/HU/felhasználói/felhasználó_fiók_jelszó_reset";
                } else if (pageOrTitle == "title") {
                    return "HU Felhasználói fiók jelszó reset";
                }
            } else if (parted[0] == "/service/activateUser?activate") {
                if (pageOrTitle == "page") {
                    return "/HU/felhasználói/felhasználó_fiók_aktiváció";
                } else if (pageOrTitle == "title") {
                    return "HU Felhasználói fiók aktiváció";
                }
            } else if (parted[0] == "/service/activatePartnerUser?activate") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/felhasználó_fiók_aktiváció";
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Felhasználói fiók aktiváció";
                }
            } else if (parted[0] == "/service/registerCompany") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/partner_regisztráció_landing_page";
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Regisztráció információs oldal";
                }
            } else if (parted[0] == "/service/viewInfo") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/partner_regisztráció_landing_page";
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Regisztráció információs oldal";
                }
            } else if (parted[0] == "/service/register") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/partner_regisztráció";
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Regisztráció";
                }
            } else if (parted[0] == "/service/resetPartnerUserPassword?reset") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/partner_felhasználó_fiók_jelszó_reset";
                } else if (pageOrTitle == "title") {
                    return "HU Partner felhasználói fiók jelszó reset";
                }
            } else if (parted[0] == "/service/deletePartner?delete") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/partner_felhasználó_fiók_törlés";
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Felhasználói fiók törlés";
                }
            } else if (parted[0] == "/service/activateMasterUser") {
                if (pageOrTitle == "page") {
                    return "/HU/partneri/privat/master_fiók_aktiváció";
                } else if (pageOrTitle == "title") {
                    return "HU Partner [PRIVÁT] - Master fiók aktiváció";
                }
            }
        }

        window.mobilecheck = function () {
            var check = false;
            (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };
    });

/*.run(['$rootScope', '$location', '$cookieStore', '$http',
    function ($rootScope, $location, $cookieStore, $http) {
        // keep user logged in after page refresh
        $rootScope.globals = $cookieStore.get('globals') || {};
        if ($rootScope.globals.currentUser) {
            $http.defaults.headers.common['Authorization'] = 'Basic ' + $rootScope.globals.currentUser.authdata; // jshint ignore:line
        }

        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            // redirect to login page if not logged in
            if ($location.path() !== '/login' && !$rootScope.globals.currentUser) {
                $location.path('/login');
            }
        });
    }]);*/
//     .config(config)
//     .run(run);

// function config($stateProvider, $urlRouterProvider) {
//         // default route
//         $urlRouterProvider.otherwise("/");

//         $stateProvider
//             .state('home', {
//                 url: '/',
//                 templateUrl: 'home/index.html',
//                 controller: 'Home.IndexController',
//                 controllerAs: 'vm',
//                 data: { activeTab: 'home' }
//             })
//             .state('account', {
//                 url: '/account',
//                 templateUrl: 'account/index.html',
//                 controller: 'Account.IndexController',
//                 controllerAs: 'vm',
//                 data: { activeTab: 'account' }
//             });
//     }

//     function run($http, $rootScope, $window) {
//         // add JWT token as default auth header
//         $http.defaults.headers.common['Authorization'] = 'Bearer ' + $window.jwtToken;

//         // update active tab on state change
//         $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
//             $rootScope.activeTab = toState.data.activeTab;
//         });
//     }

//     // manually bootstrap angular after the JWT token is retrieved from the server
//     $(function () {
//         // get JWT token from server
//         $.get('/app/token', function (token) {
//             window.jwtToken = token;

//             angular.bootstrap(document, ['app']);
//         });
//     });
//})();